(function() {
    // a11y remediation

    console.log('a11y enabled!');

    /* ==========================================================================
    = Global Accessibility Fixes 
    ========================================================================== */

    /* = Skip link
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', function() { 
        var skipLink = document.getElementById('skipLink'); 
        var target = document.getElementById('mainContainer'); 

        if (skipLink && target) { 
            skipLink.onclick = function(event) { 
                event.preventDefault(); 
                target.scrollIntoView(); 
                target.focus(); 
            }; 
        } 
    });

    /* = Keyboard functionality for mega-nav
    -------------------------------------------------------------- */

    (function () {
        function isDesktop() {
            return window.innerWidth >= 990;
        }

        if (window.nssKeyboardPatchInitialised) {
            return;
        }

        window.nssKeyboardPatchInitialised = true;

        let keyboardOpening = false;

        function enableKeyboardOpen(callback) {

            keyboardOpening = true;

            callback();

            setTimeout(() => {
                keyboardOpening = false;
            }, 300);

        }

        function forceCloseMegaNav() {
            document
                .querySelectorAll('[nss-mega-nav][aria-expanded="true"]')
                .forEach(el => {
                    el.setAttribute('aria-expanded', 'false');
                });

            document
                .querySelectorAll('nss-mega-nav[nss-mega-nav-open="true"]')
                .forEach(el => {
                    el.setAttribute('nss-mega-nav-open', 'false');
                });

            document
                .querySelectorAll('nss-mega-nav-item[nss-mega-nav-item-open="true"]')
                .forEach(el => {
                    el.setAttribute('nss-mega-nav-item-open', 'false');
                });

            document
                .querySelectorAll('[nss-mega-sub-nav-open-d="true"]')
                .forEach(el => {
                    el.setAttribute('nss-mega-sub-nav-open-d', 'false');
                });

            document
                .querySelectorAll('[nss-menu-open="true"]')
                .forEach(el => {
                    el.setAttribute('nss-menu-open', 'false');
                });

            document
                .querySelectorAll('nss-overlay')
                .forEach(overlay => {
                    overlay.style.opacity = '0';
                    overlay.style.pointerEvents = 'none';
                    overlay.style.zIndex = '-1';

                });

        }

        function interceptHoverOpen() {
            function blockHover(event) {
                if (!isDesktop()) {
                    return;
                }

                if (keyboardOpening) {
                    return;
                }

                if (!event.target?.closest) {
                    return;
                }

                const trigger = event.target.closest(
                    'button[nss-mega-nav], button[nss-mega-sub-nav-id]'
                );

                if (!trigger) {
                    return;
                }

                event.preventDefault();

                event.stopPropagation();

                if (event.stopImmediatePropagation) {
                    event.stopImmediatePropagation();
                }

                if (
                    document.querySelector(
                        'button[nss-mega-nav][aria-expanded="true"]'
                    )
                ) {
                    return;
                }

                forceCloseMegaNav();
            }

            document.addEventListener(
                'mouseenter',
                blockHover,
                true
            );

            document.addEventListener(
                'mouseover',
                blockHover,
                true
            );

            document.addEventListener(
                'pointerover',
                blockHover,
                true
            );

        }

        function attachClickNavigation() {
            document
                .querySelectorAll('button[nss-mega-nav]')
                .forEach((link) => {

                    if (link.dataset.nssClickBound) {
                        return;
                    }

                    link.dataset.nssClickBound = 'true';

                    link.addEventListener('click', (event) => {

                        if (!isDesktop()) {
                            return;
                        }

                        event.preventDefault();

                        const id =
                            link.getAttribute(
                                'nss-mega-nav'
                            );

                        const expanded =
                            link.getAttribute(
                                'aria-expanded'
                            ) === 'true';

                        if (expanded) {
                            forceCloseMegaNav();

                            return;

                        }

                        forceCloseMegaNav();

                        if (!expanded) {
                            link.setAttribute(
                                'aria-expanded',
                                'true'
                            );

                            const megaNav =
                                document.querySelector(
                                    'nss-mega-nav'
                                );

                            const panel =
                                document.querySelector(
                                    `[nss-mega-nav-item-id="${id}"]`
                                );

                            if (megaNav) {
                                megaNav.setAttribute(
                                    'nss-mega-nav-open',
                                    'true'
                                );
                            }

                            if (panel) {
                                panel.setAttribute(
                                    'nss-mega-nav-item-open',
                                    'true'
                                );
                            }

                            if (id === 'shop' && panel) {

                                const firstSubNavButton =
                                    panel.querySelector(
                                        'button.nss-mega-nav-products__button-d[nss-mega-sub-nav-id]'
                                    );

                                const firstSubNavId =
                                    firstSubNavButton?.getAttribute(
                                        'nss-mega-sub-nav-id'
                                    );

                                if (firstSubNavId) {

                                    panel
                                        .querySelectorAll(
                                            `[nss-mega-sub-nav-id="${firstSubNavId}"]`
                                        )
                                        .forEach((el) => {

                                            el.setAttribute(
                                                'nss-mega-sub-nav-open-d',
                                                'true'
                                            );

                                        });

                                    panel
                                        .querySelectorAll(
                                            `[nss-menu-id="${firstSubNavId}"]`
                                        )
                                        .forEach((el) => {

                                            el.setAttribute(
                                                'nss-menu-open',
                                                'true'
                                            );

                                        });
                                }
                            }

                            if (id === 'learn') {

                                const learnPanel =
                                    document.querySelector(
                                        'ul[nss-menu-id="learn"]'
                                    );

                                if (learnPanel) {

                                    learnPanel.setAttribute(
                                        'nss-menu-open',
                                        'true'
                                    );

                                }
                            }

                            document
                                .querySelectorAll(
                                    'nss-overlay'
                                )
                                .forEach((overlay) => {

                                    overlay.style.opacity = '1';
                                    overlay.style.pointerEvents = 'all';
                                    overlay.style.zIndex = '1000';

                                });
                        }
                    });
                });
        }

        function initNSSKeyboardHover() {
            const header = document.querySelector('nss-header');

            const topLinks = document.querySelectorAll(
                'button.nss-link-nav[nss-mega-nav]'
            );

            if (!header) {
                return;
            }

            let lastTrigger = null;

            function getSubNavButtons() {
                return Array.from(
                    document.querySelectorAll(
                        'button.nss-mega-nav-products__button-d[nss-mega-sub-nav-id]'
                    )
                );
            }

            function focusFirstSubNavButton() {
                const buttons = getSubNavButtons();

                if (buttons.length) {
                    buttons[0].focus();
                }
            }

            function focusFirstLearnCard() {
                const panel = document.querySelector(
                    'ul[nss-menu-id="learn"]'
                );

                if (!panel) {
                    return;
                }

                const card = panel.querySelector(
                    'a.nss-mega-nav-link-card'
                );

                if (card) {
                    card.focus();
                }
            }

            function focusFirstItemInPanel(id) {
                const panel = document.querySelector(
                    `[nss-menu-id="${id}"]`
                );

                if (!panel) {
                    return;
                }

                const focusable = panel.querySelector(
                    'a[href], button'
                );

                if (focusable) {
                    focusable.focus();
                }
            }

            function trapFocus(container) {
                const focusable = Array.from(
                    container.querySelectorAll(
                        'a[href], button'
                    )
                );

                if (!focusable.length) {
                    return;
                }

                const first = focusable[0];
                const last = focusable[focusable.length - 1];

                function handleTrap(e) {
                    if (e.key !== 'Tab') {
                        return;
                    }

                    if (e.shiftKey) {
                        if (document.activeElement === first) {
                            e.preventDefault();
                            last.focus();
                        }
                    } else {
                        if (document.activeElement === last) {
                            e.preventDefault();
                            first.focus();
                        }
                    }
                }

                container.addEventListener(
                    'keydown',
                    handleTrap
                );
            }

            function activateFocusTrapForShop() {
                const shop = document.querySelector(
                    '[nss-mega-nav-item-id="shop"]'
                );

                if (shop) {
                    trapFocus(shop);
                }
            }

            function activateFocusTrapForLearn() {
                const learn = document.querySelector(
                    'ul[nss-menu-id="learn"]'
                );

                if (learn) {
                    trapFocus(learn);
                }
            }

            function attachArrowKeyNavigation() {
                const buttons = getSubNavButtons();

                buttons.forEach((button, index) => {

                    button.addEventListener(
                        'keydown',
                        (event) => {

                            if (event.key === 'ArrowDown') {
                                event.preventDefault();

                                const next =
                                    buttons[index + 1] ||
                                    buttons[0];

                                next.focus();
                            }

                            if (event.key === 'ArrowUp') {
                                event.preventDefault();

                                const prev =
                                    buttons[index - 1] ||
                                    buttons[buttons.length - 1];

                                prev.focus();
                            }
                        }
                    );
                });
            }

            topLinks.forEach((link) => {
                link.addEventListener(
                    'keydown',
                    (event) => {

                        if (!isDesktop()) {
                            return;
                        }

                        if (
                            event.key === 'Enter' ||
                            event.key === ' ' ||
                            event.key === 'Spacebar'
                        ) {
                            event.preventDefault();

                            const id =
                                link.getAttribute(
                                    'nss-mega-nav'
                                );

                            lastTrigger = link;

                            enableKeyboardOpen(() => {
                                link.click();
                            });

                            if (id === 'learn') {
                                setTimeout(() => {
                                    focusFirstLearnCard();
                                    activateFocusTrapForLearn();
                                }, 60);

                            } else {
                                setTimeout(() => {
                                    focusFirstSubNavButton();
                                    attachArrowKeyNavigation();
                                    activateFocusTrapForShop();
                                }, 60);
                            }
                        }
                    }
                );
            });

            document.addEventListener(
                'keydown',
                (event) => {

                    if (!isDesktop()) {
                        return;
                    }

                    const active =
                        document.activeElement;

                    if (
                        (
                            event.key === 'Enter' ||
                            event.key === ' ' ||
                            event.key === 'Spacebar'
                        ) &&
                        active &&
                        active.matches(
                            'button[nss-mega-sub-nav-id]'
                        )
                    ) {
                        event.preventDefault();

                        const id =
                            active.getAttribute(
                                'nss-mega-sub-nav-id'
                            );

                        enableKeyboardOpen(() => {
                            active.click();
                        });

                        setTimeout(() => {
                            focusFirstItemInPanel(id);
                        }, 60);
                    }

                    if (event.key === 'Escape') {
                     
                        const openMenu = document.querySelector(
                            '[nss-mega-nav][aria-expanded="true"]'
                        );
                         
                        if (!openMenu) {
                            return;
                        }
                         
                        if (
                        document.documentElement.getAttribute(
                        'nss-cart-drawer-open'
                        ) === 'true'
                        ) {
                            return;
                        }
                         
                        if (
                        document.querySelector(
                            '.nss-cust-addresses__form[nss-form-modal-open="true"]'
                        )
                        ) {
                            return;
                        }
                         
                        event.preventDefault();
                        event.stopImmediatePropagation();
                         
                        forceCloseMegaNav();
                         
                        if (
                        typeof header.closeMegaNavEvent ===
                        'function'
                        ) {
                            header.closeMegaNavEvent();
                        }
                         
                        const trigger = lastTrigger;
                        lastTrigger = null;
                         
                        if (trigger) {
                            setTimeout(() => {
                            trigger.focus();
                        }, 80);
                        }
                         
                        return;
                    }

                }
            );
        }

        function attachShopSubNavButtons() {
            document
                .querySelectorAll(
                    'button[nss-mega-sub-nav-id]'
                )
                .forEach((button) => {

                    if (button.dataset.subnavBound) {
                        return;
                    }

                    button.dataset.subnavBound = 'true';

                    button.addEventListener(
                        'click',
                        (event) => {

                            if (window.innerWidth < 990) {
                                return;
                            }

                            event.preventDefault();

                            const subNavId =
                                button.getAttribute(
                                    'nss-mega-sub-nav-id'
                                );

                            document
                                .querySelectorAll(
                                    '[nss-mega-sub-nav-open-d="true"]'
                                )
                                .forEach((el) => {

                                    el.setAttribute(
                                        'nss-mega-sub-nav-open-d',
                                        'false'
                                    );

                                });

                            document
                                .querySelectorAll(
                                    '[nss-menu-open="true"]'
                                )
                                .forEach((el) => {

                                    el.setAttribute(
                                        'nss-menu-open',
                                        'false'
                                    );

                                });

                            document
                                .querySelectorAll(
                                    `[nss-mega-sub-nav-id="${subNavId}"]`
                                )
                                .forEach((el) => {

                                    el.setAttribute(
                                        'nss-mega-sub-nav-open-d',
                                        'true'
                                    );

                                });

                            document
                                .querySelectorAll(
                                    `[nss-menu-id="${subNavId}"]`
                                )
                                .forEach((el) => {

                                    el.setAttribute(
                                        'nss-menu-open',
                                        'true'
                                    );
                                });
                        }
                    );
                });
        }

        document.addEventListener(
        'DOMContentLoaded',
        () => {
            if (!isDesktop()) {
                return;
            }

            interceptHoverOpen();
            initNSSKeyboardHover();
            attachClickNavigation();
            attachShopSubNavButtons();
        }
        );

        document.addEventListener(
        'shopify:section:load',
        () => {
            if (!isDesktop()) {
                return;
            }

            initNSSKeyboardHover();
            attachClickNavigation();
            attachShopSubNavButtons();
        }
        );
    })();

    /* = Cart drawer focus management
    -------------------------------------------------------------- */

    let lastCartTrigger = null;

    document.addEventListener('click', (event) => {
        const trigger = event.target.closest('.nss-header__item-cart [nss-open-cart-drawer]');

        if (trigger) {
            lastCartTrigger = trigger;
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            const trigger = event.target.closest('.nss-header__item-cart [nss-open-cart-drawer]');

            if (trigger) {
                lastCartTrigger = trigger;
            }
        }
    });
    
    const html = document.documentElement; 
    const drawer = document.querySelector('nss-cart-drawer');

    function getFocusableElements() { 
        if (!drawer) return []; 
        return Array.from( drawer.querySelectorAll( 'a[href], button:not([disabled]), [role="button"], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])' ) ).filter(el => el.offsetParent !== null); 
    }
    
    function first() { 
        const focusables = getFocusableElements(); return focusables[0] || null; 
    } 
    
    function last() { 
        const focusables = getFocusableElements(); return focusables[focusables.length - 1] || null;
    } 
    
    function triggerClose() { 
        const closeBtn = drawer?.querySelector('button[nss-open-cart-drawer]');
        if (closeBtn) closeBtn.click(); 
    }
    
    function updateOverlay() { 
        requestAnimationFrame(() => { 
            const ov = document.querySelector('nss-overlay'); 
            if (!ov) return; 
            const open = html.getAttribute('nss-cart-drawer-open') === 'true'; 
            ov.style.opacity = open ? '1' : '0'; 
            ov.style.pointerEvents = open ? 'all' : 'none'; 
        }); 
    } 
    
    function trap(e) { 
        if (e.key === 'Escape') {
            if (
                html.getAttribute('nss-cart-drawer-open') !== 'true'
            ) {
                return;
            }

            e.preventDefault();
            e.stopImmediatePropagation();

            html.setAttribute(
                'nss-cart-drawer-open',
                'false'
            );

            triggerClose();

            return;
        } 
        
        if (e.key !== 'Tab') return; 
        
        const f = first(); 
        const l = last(); 
        const a = document.activeElement; 
        
        if (!f || !l) return; 
        
        if (e.shiftKey && a === f) { 
            e.preventDefault(); 
            l.focus(); 
        } 
        
        else if (!e.shiftKey && a === l) { 
            e.preventDefault(); 
            f.focus(); 
        } 
    }
    
    function activate(isOpening) { 
        const f = first(); 
        const l = last(); 
        if (!f || !l) return; 
        
        drawer.setAttribute('tabindex', '-1'); 
        drawer.focus(); 
        
        if (isOpening) { 
            setTimeout(() => f.focus(), 0); 
        }
        
        document.addEventListener('keydown', trap);
    
        drawer.addEventListener('keydown', (e) => {
            const closeBtn = drawer.querySelector('button[nss-open-cart-drawer]');
            if (!closeBtn) return;

            if (e.target === closeBtn && (e.key === 'Enter' || e.key === ' ')) {
                e.preventDefault();
                html.setAttribute('nss-cart-drawer-open', 'false');
                closeBtn.click();
            }
        });

        [f, l].forEach((el) => { 
            el.addEventListener('keydown', (e) => { 
                if (e.key === 'Enter' || e.key === ' ') { 
                    e.preventDefault(); 
                    html.setAttribute('nss-cart-drawer-open', 'false'); 
                    triggerClose(); 
                } 
            }); 
        });
        updateOverlay(); 
    }
    
    function deactivate() { 
        document.removeEventListener('keydown', trap); 
        updateOverlay(); 
    } 
    
    let wasOpen = false; 
    
    new MutationObserver(() => { 
        const open = html.getAttribute('nss-cart-drawer-open') === 'true';

        if (open && !wasOpen) {
            activate(true);
        } else if (!open && wasOpen) {
            deactivate();

            if (lastCartTrigger) {
                setTimeout(() => lastCartTrigger.focus(), 50);
            }
        }

        wasOpen = open; 
    }).observe(html, { attributes: true, attributeFilter: ['nss-cart-drawer-open'] });

    /* = Cart updates live region
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const status = document.getElementById('cart-status-message');
        const anchor = document.getElementById('cart-focus-anchor');

        if (!status || !anchor) return;

        function getItemNameFromCart(button) {
            const title = button.closest('.nss-cart__item')?.querySelector('.nss-cart__item-title');
            return title ? title.textContent.trim() : 'Item';
        }

        function getItemNameFromRecommendation(button) {
            const title = button.closest('.nss-recommendations__card')?.querySelector('.nss-recommendations__card-text h2');
            return title ? title.textContent.trim() : 'Item';
        }

        document.addEventListener('click', (e) => {
            const target = e.target;

            if (target.closest('.nss-cart__items-wrapper')) { 
                document.activeElement.blur(); 
            }

            if (target.closest('.nss-link-small')?.textContent.trim() === 'Remove') {
                const name = getItemNameFromCart(target);
                status.textContent = `${name} removed from cart`;
                return;
            }

            if (target.closest('.nss-cart__item-qty-group > button:first-child')) {
                const group = target.closest('.nss-cart__item-qty-group');
                const input = group.querySelector('input');
                const name = getItemNameFromCart(target);

                if (input) {
                    const newQty = Math.max(0, Number(input.value) - 1);
                    status.textContent = newQty === 0
                    ? `${name} removed from cart`
                    : `${name} quantity decreased to ${newQty}`;
                }
                return;
            }

            if (target.closest('.nss-cart__item-qty-group > button:last-child')) {
                const group = target.closest('.nss-cart__item-qty-group');
                const input = group.querySelector('input');
                const name = getItemNameFromCart(target);

                if (input) {
                    const newQty = Number(input.value) + 1;
                    status.textContent = `${name} quantity increased to ${newQty}`;
                }
                return;
            }

            if (target.closest('.nss-recommendations__card-form-controls button[type="submit"]')) {
                const name = getItemNameFromRecommendation(target);
                status.textContent = `${name} added to cart`;
                return;
            }
        });
    });

    /* = Descriptive labels for careers page links in footer menu
    -------------------------------------------------------------- */

    document.querySelectorAll('a[href="/pages/careers"]').forEach((link) => {
        const menuSection = link.closest('.nss-footer__menu');

        if (!menuSection) return;

        const menuTitle = menuSection.querySelector('.nss-footer__menu-title');

        if (!menuTitle) return;

        const title = menuTitle.textContent.trim();

        if (!link.hasAttribute('aria-label')) {
            link.setAttribute(
                'aria-label',
                `Careers page link in the ${title} menu`
            );
        }
    });

    /* ==========================================================================
    = NSS Hero Component Accessibility Fixes 
    ========================================================================== */

    function fixVideoFallbackAlt() {
        const observer = new MutationObserver((mutations, obs) => {
            const fallbackImages = document.querySelectorAll('video > img');

            if (!fallbackImages.length) return;

            fallbackImages.forEach(img => {
                if (!img.hasAttribute('alt')) { 
                    img.setAttribute('alt', ''); 
                }
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    fixVideoFallbackAlt();

    /* ==========================================================================
    = NSS Standard Carousel Component Accessibility Fixes 
    ========================================================================== */

    /* = Live regions
    -------------------------------------------------------------- */

    // NSS hero carousel
    //
    //
    //

    const heroCarousels = document.querySelectorAll('nss-hero-carousel');

    heroCarousels.forEach(carousel => {
        const statusEl = carousel.querySelector('[nss-hero-carousel-status]');
        if (!statusEl) return;

        const swiperEl = carousel.querySelector('.swiper');
        if (!swiperEl || !swiperEl.swiper) return;
        const swiper = swiperEl.swiper;

        let suppressUntil = 0;
        const ANNOUNCE_MS = 500;
        const TEXT_DELAY_MS = 30;
        const BUFFER_DELAY_MS = 200;

        const updateAriaLive = () => {
            if (Date.now() < suppressUntil) return;
            if (swiper.autoplay && swiper.autoplay.running) {
                statusEl.setAttribute('aria-live', 'off');
            } else {
                statusEl.setAttribute('aria-live', 'polite');
            }
        };

        const announceWithDelayedText = (text) => {
            try { statusEl.setAttribute('aria-atomic', 'true'); } catch (e) {}
            try { statusEl.setAttribute('aria-live', 'polite'); } catch (e) {}
            suppressUntil = Date.now() + ANNOUNCE_MS;

            const buffer = text === 'Slideshow paused' ? 'Pausing...' : text === 'Slideshow playing' ? 'Starting...' : 'Updating...';
            statusEl.textContent = buffer;

            setTimeout(() => {
                statusEl.textContent = text;
            }, BUFFER_DELAY_MS + TEXT_DELAY_MS);

            setTimeout(() => {
                if (Date.now() >= suppressUntil) {
                    statusEl.setAttribute('aria-live', 'off');
                }
            }, ANNOUNCE_MS);
        };

        const announceSlide = (text) => {
            statusEl.setAttribute('aria-atomic', 'true');

            statusEl.textContent = '';

            setTimeout(() => {
                statusEl.textContent = text;
            }, 50);
        };

        const readToggleState = (toggleBtn) => {
            if (!toggleBtn) return null;

            const ap = toggleBtn.getAttribute('aria-pressed');
            if (ap === 'true' || ap === 'false') {
                return ap === 'true' ? 'paused' : 'playing';
            }

            const pauseIcon = toggleBtn.querySelector('[nss-hero-carousel-toggle-pause]');
            const playIcon = toggleBtn.querySelector('[nss-hero-carousel-toggle-play]');

            if (pauseIcon) {
                const pauseVisible = !pauseIcon.hasAttribute('hidden');
                return pauseVisible ? 'playing' : 'paused';
            }
            if (playIcon) {
                const playVisible = !playIcon.hasAttribute('hidden');
                return playVisible ? 'paused' : 'playing';
            }

            return null;
        };

        updateAriaLive();

        const toggleBtn = carousel.querySelector('[nss-hero-carousel-toggle]');
        const prevBtns = carousel.querySelectorAll('.nss-hero-carousel-prev');
        const nextBtns = carousel.querySelectorAll('.nss-hero-carousel-next');
        const paginationDots = carousel.querySelectorAll('.nss-hero-carousel-slide__dot');

        const stopAutoplayForManualNavigation = () => {
            if (swiper.autoplay?.running && toggleBtn) {
                toggleBtn.click();
            }
        };

        let lastClickedControl = null;

        prevBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                lastClickedControl = 'prev';
                stopAutoplayForManualNavigation();
            });
        });

        nextBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                lastClickedControl = 'next';
                stopAutoplayForManualNavigation();
            });
        });

        paginationDots.forEach(dot => {
            dot.addEventListener('click', () => {
                lastClickedControl = 'dot';
                stopAutoplayForManualNavigation();
            });
        });

        let lastFocusedControl = null;

        toggleBtn?.addEventListener('focus', () => {
            lastFocusedControl = 'toggle';
        });

        prevBtns.forEach(btn => {
            btn.addEventListener('focus', () => {
                lastFocusedControl = 'prev';
            });
        });

        nextBtns.forEach(btn => {
            btn.addEventListener('focus', () => {
                lastFocusedControl = 'next';
            });
        });

        paginationDots.forEach(dot => {
            dot.addEventListener('focus', () => {
                lastFocusedControl = 'dot';
            });
        });

        if (toggleBtn) {
            let prevToggleState = readToggleState(toggleBtn) || null;

            toggleBtn.addEventListener('click', () => {
                setTimeout(() => {
                    const nowState = readToggleState(toggleBtn);

                    if (nowState && nowState !== prevToggleState) {
                        if (nowState === 'paused') announceWithDelayedText('Slideshow paused');
                        else announceWithDelayedText('Slideshow playing');
                    } else if (!nowState) {
                        const guessed = prevToggleState === 'playing' ? 'paused' : 'playing';
                        if (guessed === 'paused') announceWithDelayedText('Slideshow paused');
                        else announceWithDelayedText('Slideshow playing');
                    } else {
                        if (nowState === 'paused') announceWithDelayedText('Slideshow paused');
                        else announceWithDelayedText('Slideshow playing');
                    }

                    prevToggleState = nowState || (prevToggleState === 'playing' ? 'paused' : 'playing');

                    setTimeout(updateAriaLive, ANNOUNCE_MS + 50);
                }, 0);
            });
        }

        swiper.on('slideChange', () => {
            updateAriaLive();
        });

        let lastAnnouncedIndex = -1;

        swiper.on('slideChangeTransitionEnd', () => {
            if (swiper.realIndex === lastAnnouncedIndex) {
                return;
            }

            lastAnnouncedIndex = swiper.realIndex;

            const activeSlide = swiper.slides[swiper.activeIndex];

            const title =
                activeSlide
                    ?.querySelector('h1')
                    ?.textContent
                    ?.replace(/\s+/g, ' ')
                    ?.trim() || '';

            announceSlide(
                `Displaying slide ${swiper.realIndex + 1} of ${swiper.slides.length}: ${title}`
            );

            setTimeout(() => {
                const isPaused = readToggleState(toggleBtn) === 'paused';

                if (isPaused ||
                document.activeElement?.closest('.nss-hero-carousel-prev') ||
                document.activeElement?.closest('.nss-hero-carousel-next') ||
                document.activeElement?.closest('.nss-hero-carousel-slide__dot') ||
                document.activeElement?.closest('.nss-hero-carousel-toggle')) {

                    const controlToRestore = lastClickedControl || lastFocusedControl;

                    if (lastFocusedControl === 'toggle') {
                        carousel.querySelector(
                            '.swiper-slide-active .nss-hero-carousel-toggle'
                        )?.focus();
                    }

                    if (controlToRestore === 'prev') {
                        carousel.querySelector(
                            '.swiper-slide-active .nss-hero-carousel-prev'
                        )?.focus();
                    }

                    if (controlToRestore === 'next') {
                        carousel.querySelector(
                            '.swiper-slide-active .nss-hero-carousel-next'
                        )?.focus();
                    }

                    if (controlToRestore === 'dot') {
                        carousel.querySelector(
                            '.swiper-slide-active .nss-hero-carousel-slide__dot[aria-current="true"]'
                        )?.focus();
                    }
                }

                lastClickedControl = null;
            }, 0);
        });
    });

    // NSS 5050 carousel
    //
    //
    //

    const carousels5050 = document.querySelectorAll('nss-5050-carousel');

    carousels5050.forEach(carousel => {
        const statusEl = carousel.querySelector('[nss-5050-carousel-status]');
        const swiperEl = carousel.querySelector('.swiper');

        if (!statusEl || !swiperEl?.swiper) return;

        const swiper = swiperEl.swiper;

        let lastAnnouncedIndex = -1;

        swiper.on('slideChangeTransitionEnd', () => {
            if (swiper.realIndex === lastAnnouncedIndex) {
                return;
            }

            lastAnnouncedIndex = swiper.realIndex;

            const activeSlide = swiper.slides[swiper.activeIndex];

            const heading =
                activeSlide
                    ?.querySelector('h3')
                    ?.textContent
                    ?.replace(/\s+/g, ' ')
                    ?.trim() || '';

            statusEl.textContent = '';

            setTimeout(() => {
                statusEl.textContent =
                    `Displaying slide ${swiper.realIndex + 1} of ${swiper.slides.length}: ${heading}`;
            }, 50);
        });
    });

    // NSS value props carousel
    //
    //
    //

    const valuePropsCarousels = document.querySelectorAll('nss-value-props');

    valuePropsCarousels.forEach(carousel => {

        const statusEl = carousel.querySelector(
            '[nss-value-props-status]'
        );

        const swiperEl = carousel.querySelector(
            '.js-nss-value-props-cards'
        );

        if (!statusEl || !swiperEl?.swiper) {
            return;
        }

        const swiper = swiperEl.swiper;

        const wrapper = swiperEl.querySelector('.swiper-wrapper');

        if (wrapper) {
            wrapper.removeAttribute('aria-live');
        }

        let lastAnnouncement = '';

        const updateLiveRegion = () => {

            const slidesPerView = Number(swiper.params.slidesPerView) || 1;

            const visibleSlides = Array.from(swiper.slides).slice(
                swiper.activeIndex,
                swiper.activeIndex + slidesPerView
            );

            const visibleItems = visibleSlides
            .map(slide =>
                slide.querySelector('.nss-value-props__card-copy')
                    ?.textContent
                    ?.replace(/\s+/g, ' ')
                    ?.trim()
            )
            .filter(Boolean)
            .join('. ');

            const announcement =
                `Standards list updated: ${visibleItems}`;

            if (announcement === lastAnnouncement) {
                return;
            }

            lastAnnouncement = announcement;

            statusEl.textContent = '';

            setTimeout(() => {
                statusEl.textContent = announcement;
            }, 50);
        };

        swiper.on('slideChangeTransitionEnd', updateLiveRegion);
    });

    // NSS 5050 with carousel
    //
    //
    //

    const carousels5050WithCarousel = document.querySelectorAll(
    'nss-5050-with-carousel'
    );

    carousels5050WithCarousel.forEach(carousel => {

        const sectionId = carousel.dataset.sectionId;

        const statusEl = carousel.querySelector(
            `[nss-5050-with-carousel-status="${sectionId}"]`
        );

        const swiperEl = carousel.querySelector(
            '.js-nss-5050-with-carousel-images'
        );

        if (!statusEl || !swiperEl?.swiper) {
            return;
        }

        const swiper = swiperEl.swiper;

        const wrapper = swiperEl.querySelector('.swiper-wrapper');

        if (wrapper) {
            wrapper.removeAttribute('aria-live');
        }

        let lastAnnouncedIndex = -1;

        swiper.on('slideChangeTransitionEnd', () => {

            if (swiper.realIndex === lastAnnouncedIndex) {
                return;
            }

            lastAnnouncedIndex = swiper.realIndex;

            const headline =
                carousel
                    .querySelector('.nss-5050-with-carousel__headline')
                    ?.textContent
                    ?.replace(/\s+/g, ' ')
                    ?.trim() || '';

            statusEl.textContent = '';

            setTimeout(() => {
                statusEl.textContent =
                    `Displaying image ${swiper.realIndex + 1} of ${swiper.slides.length}: ${headline}`;
            }, 50);
        });
    });

    // NSS blog recipe get inspired carousel
    //
    //
    //

    const inspiredCarousels = document.querySelectorAll(
        'nss-blog-recipe-get-inspired'
    );

    inspiredCarousels.forEach(carousel => {

        const statusEl = carousel.querySelector(
            '[nss-inspired-carousel-status]'
        );

        const swiperEl = carousel.querySelector('.swiper');

        if (!statusEl || !swiperEl?.swiper) {
            return;
        }

        const swiper = swiperEl.swiper;

        const wrapper = swiperEl.querySelector('.swiper-wrapper');

        if (wrapper) {
            wrapper.removeAttribute('aria-live');
        }

        let lastAnnouncedIndex = -1;

        const announceSlide = () => {

            if (swiper.realIndex === lastAnnouncedIndex) {
                return;
            }

            lastAnnouncedIndex = swiper.realIndex;

            const activeSlide = swiper.slides[swiper.activeIndex];

            const recipeTitle =
                activeSlide
                    ?.querySelector('.lsg-inspired__article-title')
                    ?.textContent
                    ?.replace(/\s+/g, ' ')
                    ?.trim() || '';

            statusEl.textContent = '';

            setTimeout(() => {
                statusEl.textContent =
                    `Displaying recipe ${swiper.realIndex + 1} of ${swiper.slides.length}: ${recipeTitle}`;
            }, 150);
        };

        swiper.on('slideChange', announceSlide);
    });

    // NSS recommendations carousel
    //
    //
    //

    const initRecommendationsCarousel = (carousel) => {

        if (carousel.dataset.a11yInitialised === 'true') {
            return;
        }

        const statusEl = carousel.querySelector(
            '[nss-recommendations-status]'
        );

        const swiperEl = carousel.querySelector('.swiper');

        if (!statusEl || !swiperEl?.swiper) {
            return;
        }

        carousel.dataset.a11yInitialised = 'true';

        const swiper = swiperEl.swiper;

        const wrapper = swiperEl.querySelector('.swiper-wrapper');

        if (wrapper) {
            wrapper.removeAttribute('aria-live');
        }

        let lastAnnouncedIndex = swiper.realIndex;

        const announceSlide = () => {

            if (swiper.realIndex === lastAnnouncedIndex) {
                return;
            }

            lastAnnouncedIndex = swiper.realIndex;

            const activeSlide = swiper.slides[swiper.activeIndex];

            const category =
                activeSlide
                    ?.querySelector('.nss-category')
                    ?.textContent
                    ?.replace(/\s+/g, ' ')
                    ?.trim() || '';

            const product =
                activeSlide
                    ?.querySelector('.nss-recommendations__card-text h2')
                    ?.textContent
                    ?.replace(/\s+/g, ' ')
                    ?.trim() || '';

            statusEl.textContent = '';

            setTimeout(() => {
                statusEl.textContent =
                    `Displaying recommended product ${swiper.realIndex + 1} of ${swiper.slides.length}: ${product}${category ? `, ${category}` : ''}`;
            }, 150);
        };

        swiper.on('slideChange', announceSlide);
    };

    document
        .querySelectorAll('nss-recommendations')
        .forEach(initRecommendationsCarousel);

    const recommendationsObserver = new MutationObserver(() => {
        document
            .querySelectorAll('nss-recommendations')
            .forEach(initRecommendationsCarousel);
    });

    recommendationsObserver.observe(document.body, {
        childList: true,
        subtree: true
    });

    // NSS PDP when to drink carousel
    //
    //
    //

    const whenToDrinkCarousels = document.querySelectorAll(
        'nss-pdp-when-to-drink'
    );

    whenToDrinkCarousels.forEach(carousel => {

        const sectionId = carousel.dataset.sectionId;

        const statusEl = carousel.querySelector(
            `[nss-when-to-drink-status="${sectionId}"]`
        );

        if (!statusEl) {
            return;
        }

        const swipers = carousel.querySelectorAll('.swiper');

        swipers.forEach(swiperEl => {

            if (!swiperEl.swiper) {
                return;
            }

            const swiper = swiperEl.swiper;

            const wrapper = swiperEl.querySelector('.swiper-wrapper');

            if (wrapper) {
                wrapper.removeAttribute('aria-live');
            }

            let lastAnnouncedIndex = swiper.realIndex;

            const announceSlide = () => {

                if (swiper.realIndex === lastAnnouncedIndex) {
                    return;
                }

                lastAnnouncedIndex = swiper.realIndex;

                const visibleSlides = Array.from(swiper.slides).slice(
                    swiper.activeIndex,
                    swiper.activeIndex + 4
                );

                const getImageLabel = (img) => {
                    const src = img?.getAttribute('src') || '';

                    const filename = src
                        .split('/')
                        .pop()
                        .split('?')[0]
                        .replace('.svg', '')
                        .replace(/\d+/g, '')
                        .replace(/[_-]/g, ' ')
                        .replace(/\s+/g, ' ')
                        .trim();

                    return filename;
                };

                const visibleItems = visibleSlides
                .map((slide, index) => {
                    const img = slide.querySelector('img');

                    if (!img) return null;

                    const src = img.getAttribute('src') || '';

                    const filename = src
                        .split('/')
                        .pop()
                        .split('?')[0];

                    return `Image ${index + 1}: ${filename}`;
                })
                .filter(Boolean)
                .join('. ');

                statusEl.textContent = '';

                setTimeout(() => {
                    statusEl.textContent =
                        `When to drink options updated: ${visibleItems}`;
                }, 150);
            };

            swiper.on('slideChange', announceSlide);
        });
    });

    // Lsg category lists carousel
    //
    //
    //

    const customCategoryCarousels = document.querySelectorAll(
        'lsg-custom-category-lists'
    );

    customCategoryCarousels.forEach(carousel => {

        const sectionId = carousel.dataset.sectionId;

        const statusEl = carousel.querySelector(
            `[nss-custom-category-status="${sectionId}"]`
        );

        const swiperEl = carousel.querySelector('.swiper');

        if (!statusEl || !swiperEl?.swiper) {
            return;
        }

        const swiper = swiperEl.swiper;

        const wrapper = swiperEl.querySelector('.swiper-wrapper');

        if (wrapper) {
            wrapper.removeAttribute('aria-live');
        }

        let lastAnnouncedIndex = swiper.realIndex;

        const announceSlide = () => {

            if (swiper.realIndex === lastAnnouncedIndex) {
                return;
            }

            lastAnnouncedIndex = swiper.realIndex;

            const activeSlide = swiper.slides[swiper.activeIndex];

            const articleTitle =
                activeSlide
                    ?.querySelector('.lsg_custom_article_detail_new .nss-h4')
                    ?.textContent
                    ?.replace(/\s+/g, ' ')
                    ?.trim() || '';

            statusEl.textContent = '';

            setTimeout(() => {
                statusEl.textContent =
                    `Displaying article ${swiper.realIndex + 1} of ${swiper.slides.length}: ${articleTitle}`;
            }, 150);
        };

        swiper.on('slideChange', announceSlide);
    });

    /* = Group role removal
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const fixListItems = (root = document) => {
            root.querySelectorAll(
            'nss-carousel ul > div, nss-pdp-when-to-drink ul > div'
            ).forEach((div) => {
                const li = document.createElement('li');

                [...div.attributes].forEach(attr => {
                    if (attr.name !== 'role') {
                        li.setAttribute(attr.name, attr.value);
                    }
                });

                while (div.firstChild) {
                    li.appendChild(div.firstChild);
                }

                div.replaceWith(li);
            });
        };

        const fixRecommendations = (root = document) => {
            root.querySelectorAll(
            'nss-recommendations .swiper-wrapper > li[role="group"]'
            ).forEach((slide) => {
                slide.removeAttribute('role');
                slide.removeAttribute('aria-label');
            });
        };

        const runFixes = (root = document) => {
            fixListItems(root);
            fixRecommendations(root);
        };

        runFixes();

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {

            if (
                mutation.type === 'attributes' &&
                mutation.target instanceof Element
            ) {
                runFixes(mutation.target);
            }

            mutation.addedNodes.forEach((node) => {
                if (!(node instanceof Element)) return;
                runFixes(node);
            });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['role', 'aria-label']
        });
    });

    /* = Navigation labels
    -------------------------------------------------------------- */

    const formatHeading = (text) =>
    text
        .toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase());

    document.querySelectorAll('.nss-5050-with-carousel, .nss-value-props').forEach((carousel) => {
        const rawHeading = carousel.querySelector('h2, h3, [data-carousel-title]')?.textContent?.trim();

        if (!rawHeading) return;

        const heading = formatHeading(rawHeading);

        const prevBtn = carousel.querySelector('.js-nss-5050-with-carousel-nav-prev, .js-nss-value-props-nav-prev');
        const nextBtn = carousel.querySelector('.js-nss-5050-with-carousel-nav-next, .js-nss-value-props-nav-next');

        if (prevBtn) {
            prevBtn.setAttribute('aria-label', `Previous slide - ${heading}`);
        }

        if (nextBtn) {
            nextBtn.setAttribute('aria-label', `Next slide - ${heading}`);
        }
    });

    /* = Play/pause controls
    -------------------------------------------------------------- */

    // Lsg scrolling banner
    //
    //
    //

    document.querySelectorAll('.lsg-scroll-banner').forEach((banner) => {
        const button = banner.querySelector('.lsg-scroll-banner__toggle');
        const animatedContent = banner.querySelector('.lsg-scroll-banner__text-content > div');

        if (!button || !animatedContent) return;

        const pauseIcon = button.querySelector('.icon-pause');
        const playIcon = button.querySelector('.icon-play');
        const hiddenText = button.querySelector('.visually-hidden');

        button.addEventListener('click', () => {
            const isPaused =
                getComputedStyle(animatedContent).animationPlayState === 'paused';

            animatedContent.style.animationPlayState =
                isPaused ? 'running' : 'paused';

            button.setAttribute('aria-pressed', String(!isPaused));

            if (isPaused) {
                pauseIcon.style.display = '';
                playIcon.style.display = 'none';

                button.setAttribute(
                    'aria-label',
                    'Banner is playing. Pause scrolling.'
                );
            } else {
                pauseIcon.style.display = 'none';
                playIcon.style.display = '';

                button.setAttribute(
                    'aria-label',
                    'Banner is paused. Play scrolling.'
                );
            }
        });
    });

    // NSS wild carousel
    //
    //
    //

    document.querySelectorAll('nss-carousel').forEach((carousel) => {
        const button = carousel.querySelector('.nss-carousel__toggle');
        const marquee = carousel.querySelector('.nss-marquee-mode');

        if (!button || !marquee) return;

        const swiper = marquee.closest('.swiper').swiper;

        const pauseIcon = button.querySelector('.icon-pause');
        const playIcon = button.querySelector('.icon-play');
        const hiddenText = button.querySelector('.visually-hidden');

        button.addEventListener('click', () => {
            const isPaused = button.getAttribute('aria-pressed') === 'true';

            if (isPaused) {
                swiper.update();
                swiper.autoplay.start();

                pauseIcon.style.display = '';
                playIcon.style.display = 'none';

                button.setAttribute('aria-pressed', 'false');
                button.setAttribute(
                    'aria-label',
                    'Carousel is playing. Pause scrolling.'
                );

                hiddenText.textContent = 'Pause scrolling carousel';
            } else {
                swiper.autoplay.stop();

                const currentTranslate = swiper.getTranslate();

                swiper.setTransition(0);
                swiper.setTranslate(currentTranslate);
                swiper.update();

                pauseIcon.style.display = 'none';
                playIcon.style.display = '';

                button.setAttribute('aria-pressed', 'true');
                button.setAttribute(
                    'aria-label',
                    'Carousel is paused. Play scrolling.'
                );

                hiddenText.textContent = 'Play scrolling carousel';
            }
        });
    });

    /* ==========================================================================
    = NSS Product Carousel Component Accessibility Fixes 
    ========================================================================== */

    /* = Live region
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const carousels = document.querySelectorAll('nss-product-carousel');

        carousels.forEach(carousel => {
            const slides = Array.from(carousel.querySelectorAll('.swiper-slide'));

            let live = carousel.querySelector('[data-nss-carousel-live]');
            if (!live) {
                live = document.createElement('div');
                live.setAttribute('aria-live', 'polite');
                live.setAttribute('aria-atomic', 'true');
                live.setAttribute('data-nss-carousel-live', '');
                live.classList.add('visually-hidden');
                carousel.appendChild(live);
            }

            const updateLiveRegion = () => {
                const active = carousel.querySelector('.swiper-slide-active');
                if (!active) return;

                const activeIndex = slides.indexOf(active);
                if (activeIndex === -1) return;

                const windowSlides = slides.slice(activeIndex, activeIndex + 4);

                const announcements = [];

                windowSlides.forEach(slide => {
                    const card = slide.querySelector('.nss-card-product__text');
                    if (!card) return;

                    const name = card.querySelector('.nss-product-name')?.textContent?.trim();
                    const category = card.querySelector('.nss-category')?.textContent?.trim();

                    if (name) {
                        announcements.push(
                            category ? `${name} – ${category}` : name
                        );
                    }
                });

                if (announcements.length > 0) {
                    live.textContent = `Product list updated: ${announcements.join('. ')}`;
                }
            };

            const observer = new MutationObserver(updateLiveRegion);

            observer.observe(carousel, {
                attributes: true,
                subtree: true,
                attributeFilter: ['class']
            });

            updateLiveRegion();
        });
    });

    document.addEventListener('DOMContentLoaded', () => {
        const liveRegion = document.querySelector('#qty-live');

        if (!liveRegion) return;

        const quantityInputs = document.querySelectorAll('[nss-qty]');

        const announceQuantity = (value) => {
            liveRegion.textContent = '';

            setTimeout(() => {
                liveRegion.textContent = `Quantity ${value}`;
            }, 50);
        };

        quantityInputs.forEach(input => {
            input.addEventListener('change', () => {
                announceQuantity(input.value);
            });

            input.addEventListener('input', () => {
                announceQuantity(input.value);
            });
        });

        document.querySelectorAll('[nss-qty-plus]').forEach(button => {
            button.addEventListener('click', () => {
                setTimeout(() => {
                    const activeInput =
                        document.querySelector('#quantity:not([style*="display:none"])') ||
                        document.querySelector('#quantity-small');

                    if (activeInput) {
                        announceQuantity(activeInput.value);
                    }
                }, 100);
            });
        });

        /* ==========================================================================
        = NSS Buybox Component Accessibility Fixes 
        ========================================================================== */

        /* = Quantity field live region
        -------------------------------------------------------------- */

        document.querySelectorAll('[nss-qty-minus]').forEach(button => {
            button.addEventListener('click', () => {
                setTimeout(() => {
                    const activeInput =
                        document.querySelector('#quantity:not([style*="display:none"])') ||
                        document.querySelector('#quantity-small');

                    if (activeInput) {
                        announceQuantity(activeInput.value);
                    }
                }, 100);
            });
        });

        /* = Sticky bar keyboard focus activation
        -------------------------------------------------------------- */

        document.addEventListener('focusin', (e) => { 
            const sticky = document.querySelector('.nss-buybox__sticky-atc'); 
            if (!sticky) return; 
            
            if (sticky.contains(e.target)) { 
                sticky.classList.add('nss-active'); 
            } 
        });
    });

    /* ==========================================================================
    = NSS FAQs Filter Component Accessibility Fixes 
    ========================================================================== */

    /* = Dropdown ARIA controls
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const dropdowns = document.querySelectorAll('[nss-faqs-filter-dropdown]');

        dropdowns.forEach((dropdown, index) => {
            const wrapper = dropdown.closest('.nss-faqs-filter__faqs-category-filter-wrapper-inner');
            if (!wrapper) return;

            const button = wrapper.querySelector('[nss-faqs-filter-button]');
            if (!button) return;

            const dropdownId = dropdown.id || `faq-filter-dropdown-${index + 1}`;
            dropdown.id = dropdownId;

            button.setAttribute('role', 'button');
            button.setAttribute('aria-controls', dropdownId);

            const syncState = () => {
                const isOpen = dropdown.classList.contains('nss-active');

                button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

                if (isOpen) {
                    dropdown.removeAttribute('hidden');
                    dropdown.setAttribute('aria-hidden', 'false');
                } else {
                    dropdown.setAttribute('hidden', '');
                    dropdown.setAttribute('aria-hidden', 'true');
                }
            };

            syncState();

            const observer = new MutationObserver(syncState);

            observer.observe(dropdown, {
                attributes: true,
                attributeFilter: ['class']
            });

            observer.observe(button, {
                attributes: true,
                attributeFilter: ['class']
            });
        });
    });

    /* = Tab ARIA markup
    -------------------------------------------------------------- */

    function fixFaqTabsAccessibility() {
        const tabs = document.querySelectorAll('button[nss-faqs-category]');
        if (!tabs.length) return;

        tabs.forEach((tab, index) => {
            const category = tab.getAttribute('nss-faqs-category'); 
            const tabId = `faq-tab-${category}`; 
            const panelId = `faq-panel-${category}`;

            tab.id = tabId;

            const isActive = tab.classList.contains('nss-active');
            tab.setAttribute('role', 'tab'); 
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false'); 
            tab.setAttribute('aria-controls', panelId);

            const panel = document.querySelector(`[nss-faqs-items="${category}"]`);
            if (panel) {
                panel.id = panelId;
                panel.setAttribute('role', 'tabpanel');
                panel.setAttribute('aria-labelledby', tabId);
            }

            tab.addEventListener('click', () => {
                setTimeout(() => {
                    tabs.forEach((otherTab) => {
                        const active = otherTab.classList.contains('nss-active'); otherTab.setAttribute('aria-selected', active ? 'true' : 'false');
                    });
                }, 0);
            });
        });
    }

    fixFaqTabsAccessibility();

    /* = Tab ARIA controls
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', function () {
        const tablist = document.querySelector('.nss-faqs-filter__faqs-categories[role="tablist"]');
        if (!tablist) return;

        const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
        if (!tabs.length) return;

        const syncState = () => {
            tabs.forEach(tab => {
                const isActive = tab.classList.contains('nss-active');
                tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
                tab.setAttribute('tabindex', isActive ? '0' : '-1');
            });
        };

        syncState();

        tabs.forEach((tab, index) => {
            tab.addEventListener('keydown', (e) => {
            let newIndex = null;

            switch (e.key) {
                case 'ArrowRight':
                newIndex = (index + 1) % tabs.length;
                break;
                case 'ArrowLeft':
                newIndex = (index - 1 + tabs.length) % tabs.length;
                break;
                case 'Home':
                newIndex = 0;
                break;
                case 'End':
                newIndex = tabs.length - 1;
                break;
                case 'Tab':

                if (!e.shiftKey) {
                    const isActive = tab.classList.contains('nss-active');
                    if (!isActive) {
                        e.preventDefault();
                    }
                }
                return;
                default:
                return;
            }

            if (newIndex !== null) {
                e.preventDefault();
                const newTab = tabs[newIndex];

                tablist.focus();

                newTab.focus();
                setTimeout(() => newTab.focus(), 0);
            }
            });
        });

        const panels = document.querySelectorAll('[role="tabpanel"]');

        panels.forEach(panel => {
            const firstAccordion = panel.querySelector('button[nss-faq-item]');
            if (!firstAccordion) return;

            firstAccordion.addEventListener('keydown', (e) => {
                if (e.key === 'Tab' && e.shiftKey) {
                    const selectedTab = tablist.querySelector('[role="tab"][aria-selected="true"]');
                    if (selectedTab) {
                        e.preventDefault();
                        selectedTab.focus();
                    }
                }
            });
        });

        const observer = new MutationObserver(syncState);
        observer.observe(tablist, {
            attributes: true,
            subtree: true,
            attributeFilter: ['class']
        });
    });

    /* = Accordion ARIA markup
    -------------------------------------------------------------- */

    function fixFaqAccordionAccessibility() {
        const faqButtons = document.querySelectorAll('button[nss-faq-item]');

        faqButtons.forEach((btn, index) => {
            const triggerId = `faq-trigger-${index + 1}`;
            const panelId = `faq-panel-${index + 1}`;

            if (!btn.id) btn.id = triggerId;

            const panel = btn.nextElementSibling;
            if (!panel) return;

            panel.id = panelId;
            panel.setAttribute('role', 'region');
            panel.setAttribute('aria-labelledby', triggerId);
            btn.setAttribute('aria-controls', panelId);
        });

        const syncStates = () => {
            faqButtons.forEach((btn) => {
                const isOpen = btn.classList.contains('nss-active');
                btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            });
        };

        syncStates();

        const faqRoots = document.querySelectorAll('.nss-faqs-filter__faqs-items');

        faqRoots.forEach((root) => { 
            const observer = new MutationObserver(syncStates); 
            observer.observe(root, { 
                attributes: true, 
                subtree: true, 
                attributeFilter: ['class'] 
            }); 
        });
    }

    fixFaqAccordionAccessibility();

    /* = Tab link attributes
    -------------------------------------------------------------- */

    document.querySelectorAll('nss-faqs-filter .nss-faqs-filter__faqs-items li > div a[target="_blank"]').forEach(link => { 
        const text = link.textContent.trim(); 
        link.setAttribute('aria-label', `${text}, opens in a new window`); 
        link.setAttribute('rel', 'noopener'); 
    });

    /* ==========================================================================
    = NSS Accordion Group Component Accessibility Fixes 
    ========================================================================== */

    /* = Accordion ARIA markup
    -------------------------------------------------------------- */

    function fixAccordionAccessibility() {
        const accordionItems = document.querySelectorAll('.nss-accordion-item');

        const applyAttributes = () => {
            accordionItems.forEach((item, index) => {
                const btn = item.querySelector('button'); 
                const panel = item.querySelector('.nss-accodion-item__text'); 
                if (!btn || !panel) return;

                const triggerId = btn.id || `accordion-trigger-${index + 1}`; 
                const panelId = panel.id || `accordion-panel-${index + 1}`;

                btn.id = triggerId; 
                panel.id = panelId;

                btn.setAttribute('aria-controls', panelId); 
                panel.setAttribute('role', 'region'); 
                panel.setAttribute('aria-labelledby', triggerId);

                const isOpen = item.classList.contains('nss-active'); 
                btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            });
        };

        applyAttributes();

        accordionItems.forEach((item) => { 
            const btn = item.querySelector('button'); 
            if (!btn) return; 
            
            btn.addEventListener('click', () => { 
                requestAnimationFrame(() => { 
                    applyAttributes(); 
                }); 
            }); 
        });
    }

    fixAccordionAccessibility();

    /* ==========================================================================
    = NSS Press Quotes Component Accessibility Fixes 
    ========================================================================== */

    /* = Tab ARIA markup
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const components = document.querySelectorAll('nss-press-quotes');
        if (!components.length) return;

        components.forEach(root => {
            const tabs = root.querySelectorAll('.nss-press-quotes__nav-logos button.nss-press-quotes__logo');
            const panels = root.querySelectorAll('.nss-press-quotes__no-flex .swiper-slide');
            const tablist = root.querySelector('.nss-press-quotes__nav-logos');
            const listitems = root.querySelectorAll('.nss-press-quotes__nav-logos li');
            const swiperEl = root.querySelector('.swiper');
            const swiper = swiperEl && swiperEl.swiper;
            if (!tabs.length || !panels.length || !swiper) return;

            const uid = root.dataset.sectionId || Math.random().toString(36).slice(2);
            const isDesktop = () => window.innerWidth >= 990;

            function setupDesktopARIA() {
                tablist.setAttribute('role', 'tablist');
                tablist.setAttribute('aria-labelledby', 'press-quotes-heading');
                tablist.setAttribute('tabindex', '-1');

                listitems.forEach(li => li.setAttribute('role', 'presentation'));

                tabs.forEach((tab, index) => {
                    const tabId = `press-tab-${uid}-${index}`;
                    const panelId = `press-panel-${uid}-${index}`;
                    const selected = index === swiper.realIndex;
                    tab.id = tabId;
                    tab.setAttribute('role', 'tab');
                    tab.setAttribute('aria-controls', panelId);
                    tab.setAttribute('aria-selected', String(selected));
                    tab.setAttribute('tabindex', selected ? '0' : '-1');
                });

                panels.forEach((panel, index) => {
                    const tabId = `press-tab-${uid}-${index}`;
                    const panelId = `press-panel-${uid}-${index}`;
                    const active = index === swiper.realIndex;
                    panel.id = panelId;
                    panel.setAttribute('role', 'tabpanel');
                    panel.setAttribute('aria-labelledby', tabId);
                    panel.toggleAttribute('hidden', !active);
                    panel.setAttribute('tabindex', active ? '0' : '-1');
                });
            }

            function removeMobileARIA() {
                tablist.removeAttribute('role');
                tablist.removeAttribute('aria-labelledby');
                tablist.removeAttribute('tabindex');

                listitems.forEach(li => li.removeAttribute('role'));

                tabs.forEach(tab => {
                    tab.removeAttribute('role');
                    tab.removeAttribute('tabindex');
                    tab.removeAttribute('aria-selected');
                    tab.removeAttribute('aria-controls');
                });

                panels.forEach(panel => {
                    panel.removeAttribute('role');
                    panel.removeAttribute('tabindex');
                    panel.removeAttribute('aria-labelledby');
                    panel.removeAttribute('id');
                    panel.removeAttribute('hidden');
                });
            }

            function updateARIAFromIndex(index) {
                if (!isDesktop()) return;

                tabs.forEach((tab, i) => {
                    const selected = i === index;
                    tab.setAttribute('aria-selected', String(selected));
                    tab.setAttribute('tabindex', selected ? '0' : '-1');
                });

                panels.forEach((panel, i) => {
                    const active = i === index;
                    panel.toggleAttribute('hidden', !active);
                    panel.setAttribute('tabindex', active ? '0' : '-1');
                });
            }

            swiper.on('realIndexChange', () => {
                updateARIAFromIndex(swiper.realIndex);
            });

            tabs.forEach((tab, index) => {
                const last = tabs.length - 1;

                ['mouseenter', 'mouseover', 'pointermove'].forEach(evt => {
                    tab.addEventListener(evt, e => {
                        if (isDesktop()) {
                            e.stopImmediatePropagation();
                            e.preventDefault();
                        }
                    }, true);
                });

                tab.addEventListener('focus', () => {
                    if (!isDesktop()) return;
                    swiper.slideTo(index);
                });

                tab.addEventListener('click', () => {
                    if (!isDesktop()) return;
                    tab.focus();
                    swiper.slideTo(index);
                });

                tab.addEventListener('keydown', e => {
                    if (!isDesktop()) return;

                    if (e.key === 'ArrowRight') {
                        e.preventDefault();
                        const next = tabs[index + 1] || tabs[0];
                        tablist.focus();
                        next.focus();
                        swiper.slideTo([...tabs].indexOf(next));
                    }

                    if (e.key === 'ArrowLeft') {
                        e.preventDefault();
                        const prev = tabs[index - 1] || tabs[last];
                        tablist.focus();
                        prev.focus();
                        swiper.slideTo([...tabs].indexOf(prev));
                    }

                    if (e.key === 'Home') {
                        e.preventDefault();
                        tablist.focus();
                        tabs[0].focus();
                        swiper.slideTo(0);
                    }

                    if (e.key === 'End') {
                        e.preventDefault();
                        tablist.focus();
                        tabs[last].focus();
                        swiper.slideTo(last);
                    }

                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        swiper.slideTo(index);
                    }
                });
            });

            if (isDesktop()) {
                setupDesktopARIA();
                updateARIAFromIndex(swiper.realIndex);
            } else {
                removeMobileARIA();
            }

            let lastDesktop = isDesktop();

            window.addEventListener('resize', () => {
                const nowDesktop = isDesktop();
                if (nowDesktop !== lastDesktop) {
                    lastDesktop = nowDesktop;
                    if (nowDesktop) {
                        setupDesktopARIA();
                        updateARIAFromIndex(swiper.realIndex);
                    } else {
                        removeMobileARIA();
                    }
                }
            });
        });
    });

    /* ==========================================================================
    = NSS Jobs Component Accessibility Fixes 
    ========================================================================== */

    /* = Combobox ARIA controls
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const initOfficeCombo = (root) => {
            const label = root.querySelector('.nss-jobs__label');
            const trigger = root.querySelector('.nss-jobs__select-box');
            const menu = root.querySelector('.nss-jobs__dropdown-menu');
            const items = Array.from(root.querySelectorAll('.nss-jobs__menu-item'));

            if (!trigger || !menu || !items.length) return;

            const name = label?.textContent?.trim() || 'Office';

            trigger.setAttribute('tabindex', '0');
            trigger.setAttribute('role', 'combobox');
            trigger.setAttribute('aria-expanded', 'false');
            trigger.setAttribute('aria-haspopup', 'listbox');
            trigger.setAttribute('aria-label', name);

            menu.setAttribute('role', 'listbox');

            items.forEach((item) => {
                item.setAttribute('role', 'option');
                item.setAttribute('tabindex', '-1');
            });

            const openMenu = () => {
                trigger.setAttribute('aria-expanded', 'true');
                menu.style.display = 'block';
            };

            const closeMenu = () => {
                trigger.setAttribute('aria-expanded', 'false');
                menu.style.display = 'none';
                trigger.removeAttribute('aria-activedescendant');
                items.forEach(i => i.classList.remove('nss-option-focus'));
            };

            const focusItem = (index) => {
                const item = items[index];
                if (!item) return;

                items.forEach(i => i.classList.remove('nss-option-focus'));
                item.classList.add('nss-option-focus');

                if (!item.id) item.id = `opt-${Date.now()}-${index}`;
                trigger.setAttribute('aria-activedescendant', item.id);
            };

            let typeBuffer = '';
            let typeTimeout;

            const toggleMenu = () => {
                const expanded = trigger.getAttribute('aria-expanded') === 'true';
                if (expanded) {
                    closeMenu();
                } else {
                    openMenu();
                }
            };

            trigger.addEventListener('click', toggleMenu);

            trigger.addEventListener('keydown', (e) => {
                const key = e.key;
                const expanded = trigger.getAttribute('aria-expanded') === 'true';
                const hasVisualFocus = items.some(i => i.classList.contains('nss-option-focus'));

                if (key.length === 1 && key.match(/^[a-z0-9]$/i)) {
                    typeBuffer += key.toLowerCase();

                    clearTimeout(typeTimeout);
                    typeTimeout = setTimeout(() => {
                        typeBuffer = '';
                    }, 500);

                    const matchIndex = items.findIndex(i =>
                        i.textContent.trim().toLowerCase().startsWith(typeBuffer)
                    );

                    if (matchIndex !== -1) {
                        if (!expanded) openMenu();
                        focusItem(matchIndex);
                    }

                    return;
                }

                if (key === 'ArrowDown') {
                    e.preventDefault();

                    if (!expanded) {
                        openMenu();
                        return;
                    }

                    const currentIndex = items.findIndex(i => i.classList.contains('nss-option-focus'));
                    const nextIndex = Math.min(currentIndex + 1, items.length - 1);
                    focusItem(nextIndex);
                    return;
                }

                if (key === 'ArrowUp' && !e.altKey) {
                    e.preventDefault();

                    if (!expanded) {
                        openMenu();
                        focusItem(0);
                        return;
                    }

                    const currentIndex = items.findIndex(i => i.classList.contains('nss-option-focus'));
                    const prevIndex = Math.max(currentIndex - 1, 0);
                    focusItem(prevIndex);
                    return;
                }

                if (key === 'Home' || (key === 'ArrowLeft' && !e.altKey)) {
                    e.preventDefault();
                    if (!expanded) openMenu();
                    focusItem(0);
                    return;
                }

                if (key === 'End' || (key === 'ArrowRight' && !e.altKey)) {
                    e.preventDefault();
                    if (!expanded) openMenu();
                    focusItem(items.length - 1);
                    return;
                }

                if (key === 'Enter' || key === ' ' || (key === 'ArrowUp' && e.altKey)) {
                    e.preventDefault();

                    if (!expanded) {
                        toggleMenu();
                        return;
                    }

                    const activeIndex = items.findIndex(i => i.classList.contains('nss-option-focus'));
                    if (activeIndex !== -1) {
                        items[activeIndex].click();
                    }

                    closeMenu();
                    return;
                }

                if (key === 'Escape') {
                    e.preventDefault();
                    closeMenu();
                    return;
                }

                if (key === 'Tab') {
                    const expanded = trigger.getAttribute('aria-expanded') === 'true';

                    if (expanded) {
                        const activeIndex = items.findIndex(i => i.classList.contains('nss-option-focus'));
                        const indexToSelect = activeIndex !== -1 ? activeIndex : 0;

                        items[indexToSelect].click();
                        closeMenu();
                    }

                    requestAnimationFrame(() => {
                        const firstLink = document.querySelector('.nss-jobs__item-btn');
                        if (firstLink) firstLink.focus();
                    });

                    return;
                }
            });
        };

        document.querySelectorAll('.nss-jobs__filter-container').forEach(initOfficeCombo);

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType !== 1) return;

                    if (node.matches?.('.nss-jobs__filter-container')) {
                        initOfficeCombo(node);
                    }

                    node.querySelectorAll?.('.nss-jobs__filter-container').forEach(initOfficeCombo);
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });

    /* = Job title heading level change
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const upgradeHeading = (node) => {
            if (
            node.tagName &&
            node.tagName.toLowerCase() === 'h3' &&
            node.classList.contains('nss-jobs__item-title')
            ) {
                const h4 = document.createElement('h4');
                h4.className = node.className;
                h4.innerHTML = node.innerHTML;
                node.replaceWith(h4);
            }
        };

        document.querySelectorAll('.nss-jobs__item-title').forEach(upgradeHeading);

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType !== 1) return;

                    upgradeHeading(node);

                    node.querySelectorAll?.('.nss-jobs__item-title').forEach(upgradeHeading);
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });

    /* = Apply now button label
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const upgradeApplyLink = (root) => {
            const link = root.querySelector('.nss-jobs__item-btn');
            const title = root.querySelector('.nss-jobs__item-title');

            if (!link || !title) return;

            const jobTitle = title.textContent.trim().replace(/\s+/g, ' ');
            const descriptive = `Apply Now – ${jobTitle}`;

            link.setAttribute('aria-label', descriptive);
        };

        document.querySelectorAll('.nss-jobs__item-action').forEach((card) => {
            upgradeApplyLink(card.closest('.nss-jobs__item'));
        });

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType !== 1) return;

                if (node.matches?.('.nss-jobs__item')) {
                    upgradeApplyLink(node);
                }

                node.querySelectorAll?.('.nss-jobs__item').forEach(upgradeApplyLink);
            });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });

    /* ==========================================================================
    = Multimedia Block Component Accessibility Fixes 
    ========================================================================== */

    /* = Video controls focus management
    -------------------------------------------------------------- */

    (() => {
        const activatedVideos = new WeakSet();

        function lockVideo(video) {
            if (!video || activatedVideos.has(video)) return;

            video.removeAttribute('controls');
            video.tabIndex = -1;
            video.setAttribute('aria-hidden', 'true');
        }

        function unlockVideo(video, trigger) {
            if (!video) return;

            activatedVideos.add(video);

            video.setAttribute('controls', '');
            video.removeAttribute('tabindex');
            video.removeAttribute('aria-hidden');

            if (trigger) {
                trigger.hidden = true;
                trigger.setAttribute('aria-hidden', 'true');
            }

            video.play().catch(() => {});
            video.focus();
        }

        function initCard(card) {
            const video = card.querySelector('video');
            const playButton = card.querySelector('.js-play');

            if (!video || !playButton) return;

            lockVideo(video);

            if (playButton.dataset.a11yBound) return;
            playButton.dataset.a11yBound = 'true';

            playButton.addEventListener('click', () => {
                unlockVideo(video, playButton);
            });
        }

        document
            .querySelectorAll('.multimedia-card__media')
            .forEach(initCard);

        const videoObserver = new MutationObserver(() => {
            document.querySelectorAll('.multimedia-card__media video').forEach(video => {
            if (!activatedVideos.has(video) && video.hasAttribute('controls')) {
                lockVideo(video);
            }
            });
        });

        videoObserver.observe(document.body, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['controls']
        });

        const domObserver = new MutationObserver(() => {
            document
            .querySelectorAll('.multimedia-card__media')
            .forEach(initCard);
        });

        domObserver.observe(document.body, {
            subtree: true,
            childList: true
        });
    })();

    /* = Add keyboard focus to dynamically loaded multimedia blocks
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const blocks = document.querySelectorAll('multimedia-block');

        blocks.forEach(block => {
            const grid = block.querySelector('.multimedia__grid');
            const loadMoreBtn = block.querySelector('.js-load-more');

            if (!grid || !loadMoreBtn) return;

            let previousCount = 0;
            let waiting = false;

            const observer = new MutationObserver(() => {
                if (!waiting) return;

                const cards = grid.querySelectorAll('.multimedia-card');

                if (cards.length > previousCount) {
                    const firstNew = cards[previousCount];

                    if (firstNew) {
                        const link = firstNew.querySelector('a');

                        if (link) {
                            link.focus();
                        } else {
                            firstNew.setAttribute('tabindex', '-1');
                            firstNew.focus();
                        }
                    }

                    waiting = false;
                }
            });

            observer.observe(grid, { childList: true, subtree: true });

            loadMoreBtn.addEventListener('click', () => {
                const cards = grid.querySelectorAll('.multimedia-card');
                previousCount = cards.length;
                waiting = true;
            });
        });
    });

    /* ==========================================================================
    = NSS Media Blog Component Accessibility Fixes 
    ========================================================================== */

    /* = Current page announcement
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const activeItem = document.querySelector('.multimedia__nav-item.is-active a');
        if (activeItem) {
            activeItem.setAttribute('aria-current', 'page');
        }
    });

    /* ==========================================================================
    = NSS TLP Header Component Accessibility Fixes 
    ========================================================================== */

    /* = Hidden video controls focus management
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(m => {
            if (m.attributeName === 'data-open') {
                const modal = m.target;
                const isOpen = modal.getAttribute('data-open') === 'true';
                modal.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
            }
            });
        });

        document.querySelectorAll('.tlp-slider__video-modal').forEach(modal => {
            modal.setAttribute('aria-hidden', 'true');
            observer.observe(modal, { attributes: true });
        });
    });

    /* ==========================================================================
    = NSS TLP Slider Component Accessibility Fixes 
    ========================================================================== */

    /* = Tabindex and role attributes removal
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const slider = document.querySelector('.tlp-slider__slick');
        if (!slider) return;

        const waitForSlick = setInterval(() => {
            if (slider.classList.contains('slick-initialized')) {
                console.log('Slick is now initialized');

                slider.querySelectorAll('.slick-slide, .slick-cloned').forEach(slide => {
                    slide.removeAttribute('tabindex');
                    slide.removeAttribute('role');
                });

                $(slider).on('afterChange reInit', () => {
                    slider.querySelectorAll('.slick-slide, .slick-cloned').forEach(slide => {
                        slide.removeAttribute('tabindex');
                        slide.removeAttribute('role');
                    });
                });

                clearInterval(waitForSlick);
            }
        }, 100);
    });

    /* = Hidden controls focus management
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(m => {
            if (m.attributeName === 'data-open') {
                const modal = m.target;
                const isOpen = modal.getAttribute('data-open') === 'true';
                modal.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
            }
            });
        });

        document.querySelectorAll('.tlp-slider__video-modal').forEach(modal => {
            modal.setAttribute('aria-hidden', 'true');
            observer.observe(modal, { attributes: true });
        });
    });

    /* ==========================================================================
    = Auth Flow Page Accessibility Fixes 
    ========================================================================== */

    /* = Alert messages focus management
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', function () {
        const patchContainers = () => {
            const errorContainers = document.querySelectorAll('.nss-form-errors');
            errorContainers.forEach(container => {
                container.setAttribute('role', 'alert');
                container.setAttribute('tabindex', '-1');
                container.focus();
            });

            const successContainers = document.querySelectorAll('.nss-form-success');
            successContainers.forEach(container => {
                container.setAttribute('role', 'status');
                container.setAttribute('tabindex', '-1');
                container.focus();
            });
        };

        patchContainers();

        const observer = new MutationObserver(patchContainers);

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });

    /* = Custom form validation
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('form').forEach(form => {
            form.setAttribute('novalidate', 'novalidate');

            const formType = form.querySelector('input[name="form_type"]')?.value;

            switch (formType) {
                case 'customer_login':
                    initialiseLoginForm(form);
                    break;

                case 'create_customer':
                    initialiseRegisterForm(form);
                    break;

                case 'recover_customer_password':
                    initialiseRecoverForm(form);
                    break;

                case 'customer_address':
                    initialiseAddressForm(form);
                    break;
            }
        });
    });

    function showError(input, errorElement, message) {
        if (!input || !errorElement) return;

        input.setAttribute('aria-invalid', 'true');
        errorElement.textContent = message;
    }

    function clearError(input, errorElement) {
        if (!input || !errorElement) return;

        input.setAttribute('aria-invalid', 'false');
        errorElement.textContent = '';
    }

    function focusFirstInvalid(field) {
        if (!field) return;

        setTimeout(() => {
            field.focus();
        }, 0);
    }

    function validateRequired(field, errorElement, message) {
        if (!field) return true;

        if (!String(field.value).trim()) {
            showError(field, errorElement, message);
            return false;
        }

        clearError(field, errorElement);
        return true;
    }

    function validateEmail(field, errorElement) {
        if (!field) return true;

        if (!field.value.trim()) {
            showError(field, errorElement, 'Enter your email address.');
            return false;
        }

        if (!field.value.includes('@')) {
            showError(field, errorElement, 'Enter a valid email address.');
            return false;
        }

        clearError(field, errorElement);
        return true;
    }

    function initialiseLoginForm(form) {
        const email = form.querySelector('#customer-email, [name="customer[email]"]');
        const password = form.querySelector('#customer-password, [name="customer[password]"]');

        const emailError = form.querySelector('#customer-email-error');
        const passwordError = form.querySelector('#customer-password-error');

        email?.addEventListener('input', () => {
            clearError(email, emailError);
        });

        password?.addEventListener('input', () => {
            clearError(password, passwordError);
        });

        form.addEventListener('submit', e => {
            let valid = true;
            let firstInvalidField = null;

            if (!validateEmail(email, emailError)) {
                valid = false;
                firstInvalidField ??= email;
            }

            if (!validateRequired(password, passwordError, 'Enter the password.')) {
                valid = false;
                firstInvalidField ??= password;
            }

            if (!valid) {
                e.preventDefault();
                e.stopImmediatePropagation();
                focusFirstInvalid(firstInvalidField);
            }
        }, true);
    }

    function initialiseRegisterForm(form) {
        const email = form.querySelector('[name="customer[email]"]');
        const password = form.querySelector('[name="customer[password]"]');
        const confirmPassword = form.querySelector('#customer-confirm-password');

        const emailError = form.querySelector('#register-email-error');
        const passwordError = form.querySelector('#register-password-error');
        const confirmPasswordError = form.querySelector('#register-confirm-password-error');

        email?.addEventListener('input', () => {
            clearError(email, emailError);
        });

        password?.addEventListener('input', () => {
            clearError(password, passwordError);
        });

        confirmPassword?.addEventListener('input', () => {
            if (!confirmPassword.value.trim()) {
                clearError(confirmPassword, confirmPasswordError);
                return;
            }

            if (password.value !== confirmPassword.value) {
                showError(
                    confirmPassword,
                    confirmPasswordError,
                    'Passwords do not match.'
                );
                return;
            }

            clearError(confirmPassword, confirmPasswordError);
        });

        form.addEventListener('submit', e => {
            let valid = true;
            let firstInvalidField = null;

            if (!validateEmail(email, emailError)) {
                valid = false;
                firstInvalidField ??= email;
            }

            if (!validateRequired(password, passwordError, 'Enter the password.')) {
                valid = false;
                firstInvalidField ??= password;
            }

            if (!confirmPassword.value.trim()) {
                valid = false;

                showError(
                    confirmPassword,
                    confirmPasswordError,
                    'Re-enter your chosen password.'
                );

                firstInvalidField ??= confirmPassword;
            } else if (password.value !== confirmPassword.value) {
                valid = false;

                showError(
                    confirmPassword,
                    confirmPasswordError,
                    'Passwords do not match.'
                );

                firstInvalidField ??= confirmPassword;
            } else {
                clearError(confirmPassword, confirmPasswordError);
            }

            if (!valid) {
                e.preventDefault();
                e.stopImmediatePropagation();
                focusFirstInvalid(firstInvalidField);
            }
        }, true);
    }

    function initialiseRecoverForm(form) {
        const email = form.querySelector(
            '#RecoverEmail, [name="email"], [name="customer[email]"]'
        );

        const emailError = form.querySelector('#recover-email-error');

        email?.addEventListener('input', () => {
            clearError(email, emailError);
        });

        form.addEventListener('submit', e => {
            let valid = true;
            let firstInvalidField = null;

            if (!validateEmail(email, emailError)) {
                valid = false;
                firstInvalidField ??= email;
            }

            if (!valid) {
                e.preventDefault();
                e.stopImmediatePropagation();
                focusFirstInvalid(firstInvalidField);
            }
        }, true);
    }

    function resetValidation(form) {
        form.querySelectorAll('[aria-invalid="true"]').forEach(field => {
            field.setAttribute('aria-invalid', 'false');
        });
     
        form.querySelectorAll('.nss-form-error').forEach(error => {
            error.textContent = '';
        });
    }

    function initialiseAddressForm(form) {
        const address1 = form.querySelector('[name="address[address1]"]');
        const city = form.querySelector('[name="address[city]"]');
        const country = form.querySelector('[name="address[country]"]');
        const province = form.querySelector('[name="address[province]"]');
        const zip = form.querySelector('[name="address[zip]"]');

        const address1Error = form.querySelector('[data-error="address1"]');
        const cityError = form.querySelector('[data-error="city"]');
        const countryError = form.querySelector('[data-error="country"]');
        const provinceError = form.querySelector('[data-error="province"]');
        const zipError = form.querySelector('[data-error="zip"]');

        address1?.addEventListener('input', () => {
            clearError(address1, address1Error);
        });

        city?.addEventListener('input', () => {
            clearError(city, cityError);
        });

        country?.addEventListener('change', () => {
            clearError(country, countryError);
        });

        province?.addEventListener('change', () => {
            clearError(province, provinceError);
        });

        zip?.addEventListener('input', () => {
            clearError(zip, zipError);
        });

        form.addEventListener('submit', e => {
            let valid = true;
            let firstInvalidField = null;

            if (!validateRequired(address1, address1Error, 'Address line 1 is required.')) {
                valid = false;
                firstInvalidField ??= address1;
            }

            if (!validateRequired(city, cityError, 'City is required.')) {
                valid = false;
                firstInvalidField ??= city;
            }

            if (!validateRequired(country, countryError, 'Country is required.')) {
                valid = false;
                firstInvalidField ??= country;
            }

            if (!validateRequired(province, provinceError, 'State is required.')) {
                valid = false;
                firstInvalidField ??= province;
            }

            if (!validateRequired(zip, zipError, 'Zip is required.')) {
                valid = false;
                firstInvalidField ??= zip;
            }

            if (!valid) {
                e.preventDefault();
                e.stopImmediatePropagation();
                focusFirstInvalid(firstInvalidField);
            }
        }, true);
    }

    const closeButtons = document.querySelectorAll(
        '[nss-form-modal-close]'
    );
     
    closeButtons.forEach(button => {
        button.addEventListener('click', () => {
            const form = button.closest('.nss-cust-addresses__form')?.querySelector('form');
         
            if (form) {
                resetValidation(form);
            }
        });
    });

    /* = Password visibility button labels
    -------------------------------------------------------------- */

    document.addEventListener('click', function (e) { 
        const btn = e.target.closest('[nss-toggle-password-visibility]'); 
        if (!btn) return; 
        
        const current = btn.getAttribute('aria-pressed') === 'true'; 
        btn.setAttribute('aria-pressed', String(!current)); 
    });

    /* = Dialog focus trap 
    -------------------------------------------------------------- */

    const modalSelector = '.nss-cust-addresses__form[nss-form-modal-open="true"]';
    const firstSelector = 'fieldset input[type=checkbox]';
    const lastSelector = 'button[nss-form-modal-close]';

    function getOpenModals() {
        return document.querySelectorAll(modalSelector);
    }

    function getActiveModal() {
        const modals = getOpenModals();
        return Array.from(modals).find(m => m.contains(document.activeElement)) || null;
    }

    function getFirst(modal) {
        return modal.querySelector(firstSelector)
            || modal.querySelector('input, select, textarea, button:not([nss-form-modal-close])');
    }

    function getLast(modal) {
        return modal.querySelector(lastSelector);
    }

    let lastTrigger = null;

    document.addEventListener('click', function (e) {
        const trigger = e.target.closest('button[nss-form-modal]');
        if (trigger) {
            lastTrigger = trigger;
        }
    });

    document.addEventListener('keydown', function (e) {
        if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
            const modal = getActiveModal();
            if (!modal) return;

            if (!modal.contains(document.activeElement)) {
                const first = getFirst(modal);
                if (first) {
                    first.focus();
                }
            }
        }

        if (e.key === 'Escape') {

            const modal = getActiveModal();

            if (!modal) {
                return;
            }

            e.preventDefault();
            e.stopImmediatePropagation();

            const closeBtn = getLast(modal);

            if (closeBtn) {
                closeBtn.click();
            }

            const trigger = lastTrigger;
            lastTrigger = null;

            if (trigger) {
                setTimeout(() => {
                    trigger.focus();
                }, 0);
            }

            return;
        }

        if (e.key !== 'Tab') return;

        const modal = getActiveModal();
        if (!modal) return;
        if (!modal.contains(document.activeElement)) return;

        const first = getFirst(modal);
        const last = getLast(modal);
        if (!first || !last) return;

        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
            return;
        }

        if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
            return;
        }
    });

    const addressModalObserver = new MutationObserver(() => {
        const modals = getOpenModals();

        modals.forEach(modal => {
            const first = getFirst(modal);
            if (first) {
                setTimeout(() => first.focus(), 0);
            }
        });

        if (!modals.length && lastTrigger) {
            setTimeout(() => lastTrigger.focus(), 0);
        }
    });

    addressModalObserver.observe(document.body, {
        attributes: true,
        subtree: true,
        attributeFilter: ['nss-form-modal-open']
    });

    /* ==========================================================================
    = About Page Accessibility Fixes 
    ========================================================================== */

    /* = Learn more button label
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        if (
        window.location.pathname === '/pages/our-story' ||
        window.location.pathname === '/pages/our-story/'
    ) {
        document.querySelectorAll('a').forEach(link => {
            if (
                link.href.includes('/pages/impact') &&
                link.textContent.trim() === 'Learn More'
            ) {
                link.setAttribute(
                    'aria-label',
                    'Learn More about Our Impact'
                );
            }
        });
      }
    });

    /* ==========================================================================
    = Contact Page Accessibility Fixes 
    ========================================================================== */

    /* = Remove submit button title
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', function () {
        const contactButton = document.querySelector('#contact_form .nss-button span .nss-icon-social-email');
        if (contactButton) {
            contactButton.setAttribute('aria-hidden', 'true');
            const title = contactButton.querySelector('title');
            if (title) title.remove();
        }
    });

    /* ==========================================================================
    = Careers Page Accessibility Fixes 
    ========================================================================== */

    /* = See more button labels
    -------------------------------------------------------------- */

    if (
        window.location.pathname === '/pages/careers' ||
        window.location.pathname === '/pages/careers/'
    ) {
        document.querySelectorAll('a[href="#jobs"]').forEach(link => {
            const section = link.closest('nss-5050-column, nss-hero');
             
            if (!section) return;
             
            const heading = section.querySelector('h1, h2, h3, h4, h5, h6');
             
            if (heading) {
                link.setAttribute(
                'aria-label',
                `See Job Openings - ${heading.textContent.trim()} section link`
                );
            }
        });
    }

    /* = Profile card image alt text removal
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const applyAltText = (root) => {
            const img = root.querySelector('.nss-profile-card__card-image img');
            const title = root.querySelector('.nss-profile-card__card-title');

            if (!img || !title) return;

            const raw = title.textContent.trim().replace(/\s+/g, ' ');
            const altText = `Profile photo for: ${raw}`;

            img.setAttribute('alt', altText);
        };

        document.querySelectorAll('.nss-carousel-slide-profile-card__card')
            .forEach(applyAltText);

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType !== 1) return;

                    if (node.matches?.('.nss-carousel-slide-profile-card__card')) {
                        applyAltText(node);
                    }

                    node.querySelectorAll?.('.nss-carousel-slide-profile-card__card')
                    .forEach(applyAltText);
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });

    /* ==========================================================================
    = Subscribe Page Accessibility Fixes 
    ========================================================================== */

    if (
        window.location.pathname === '/pages/subscribe' ||
        window.location.pathname === '/pages/subscribe/'
    ) {

        /* = Subscribe today button labels
        -------------------------------------------------------------- */

        function addAriaLabels() {
            const buttons = [...document.querySelectorAll('.nss-button')]
                .filter(btn => btn.textContent.includes('Subscribe Today'));

            if (buttons[0]) {
                buttons[0].setAttribute(
                    'aria-label',
                    'Subscribe today - Commit to Coconuts - view purchase options'
                );
            }

            if (buttons[1]) {
                buttons[1].setAttribute(
                    'aria-label',
                    'Subscribe today - Never Running Out of Coconuts Has Never Been Easier - view purchase options'
                );
            }
        }

        addAriaLabels();

        const observer = new MutationObserver(addAriaLabels);

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        /* = Change incorrect h1 to h3
        -------------------------------------------------------------- */

        function fixBuyboxHeadings() {
            const badHeadings = document.querySelectorAll('.nss-buybox__heading h1.nss-h3');
            if (!badHeadings.length) return false;

            badHeadings.forEach(h1 => {
                const h3 = document.createElement('h3');
                h3.className = h1.className;
                h3.innerHTML = h1.innerHTML;
                h1.replaceWith(h3);
            });

            return true;
        }

        document.addEventListener('DOMContentLoaded', function () {
            if (fixBuyboxHeadings()) return;

            const observer = new MutationObserver(() => {
                if (fixBuyboxHeadings()) {
                    observer.disconnect();
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }

    /* ==========================================================================
    = Coconut Grove Page Accessibility Fixes 
    ========================================================================== */

    if (
        window.location.pathname === "/pages/coconut_grove" ||
        window.location.pathname === "/pages/coconut_grove/"
    ) {

        document.addEventListener("DOMContentLoaded", function () {

            /* = Add alt text
            -------------------------------------------------------------- */

            const img = document.querySelector(".roblox-hero__logo-media img"); 
            if (img && !img.hasAttribute("alt")) { 
                img.setAttribute("alt", "Vita Coco logo"); 
            }

            /* = Remove SVG screen reader detection
            -------------------------------------------------------------- */

            document.querySelectorAll(".nss-icon-arrow").forEach(svg => { 
                svg.removeAttribute("role"); 
                svg.removeAttribute("aria-labelledby"); 
                svg.setAttribute("aria-hidden", "true"); 
                svg.setAttribute("focusable", "false"); 
            });

            /* = Button labels
            -------------------------------------------------------------- */

            window.addEventListener('load', function () {
                document.querySelectorAll('div.roblox-logos-txt__text a[href*="Vita-Coco-The-Coconut-Grove"]').forEach(function (a) { 
                    if (!a.hasAttribute('aria-label')) { 
                        a.setAttribute('aria-label', 'here - enter the Vita Coco Roblox game link'); 
                    } 
                });

                document.querySelectorAll('a.nss-cta.nss-button[href="/products/coconut-water"]').forEach(function (a) {
                    if (!a.hasAttribute('aria-label')) {
                        a.setAttribute('aria-label', 'Shop Vita Coco Coconut Water');
                    }
                });

                document.querySelectorAll('a.nss-cta.nss-button[href="/products/extra-coconut"]').forEach(function (a) {
                    if (!a.hasAttribute('aria-label')) {
                        a.setAttribute('aria-label', 'Shop Vita Coco Extra Coconut');
                    }
                });
            });
        });
    }

    /* ==========================================================================
    = Farmers Organic Sourcing Accessibility Fixes 
    ========================================================================== */

    if (
        window.location.pathname === '/pages/farmers-organic-sourcing' ||
        window.location.pathname === '/pages/farmers-organic-sourcing/'
    ) {

        /* = Control labels
        -------------------------------------------------------------- */

        document.addEventListener('DOMContentLoaded', () => {
            const fixArrows = () => {
                document.querySelectorAll('.slick-prev').forEach(btn => {
                btn.setAttribute('aria-label', 'Previous slide');
                    btn.querySelectorAll('svg').forEach(svg => {
                        svg.setAttribute('aria-hidden', 'true');
                        svg.setAttribute('focusable', 'false');
                    });
                });

                document.querySelectorAll('.slick-next').forEach(btn => {
                    btn.setAttribute('aria-label', 'Next slide');
                    btn.querySelectorAll('svg').forEach(svg => {
                        svg.setAttribute('aria-hidden', 'true');
                        svg.setAttribute('focusable', 'false');
                    });
                });
            };

            fixArrows();

            new MutationObserver(() => {
                fixArrows();
            }).observe(document.body, { childList: true, subtree: true });
        });

        /* = Tab focus management
        -------------------------------------------------------------- */

        document.addEventListener('DOMContentLoaded', () => {
            const tabs = Array.from(document.querySelectorAll('[role="tab"]'));

            tabs.forEach(tab => {
                tab.addEventListener('click', () => {
                const id = tab.getAttribute('aria-controls');
                const panel = document.getElementById(id);

                tabs.forEach(t => {
                    t.setAttribute('aria-selected', 'false');
                    t.setAttribute('tabindex', '-1');
                });

                tab.setAttribute('aria-selected', 'true');
                tab.setAttribute('tabindex', '0');

                document.querySelectorAll('[role="tabpanel"]').forEach(p => {
                    p.hidden = true;
                });

                panel.hidden = false;
                panel.focus();
                });
            });

            tabs.forEach(tab => {
                tab.addEventListener('keydown', e => {
                const i = tabs.indexOf(tab);

                if (e.key === 'ArrowRight') {
                    const next = tabs[i + 1] || tabs[0];
                    next.focus();
                }

                if (e.key === 'ArrowLeft') {
                    const prev = tabs[i - 1] || tabs[tabs.length - 1];
                    prev.focus();
                }
                });
            });
        });

        /* = Hidden menu links focus management
        -------------------------------------------------------------- */

        const toggle = document.querySelector('.tlp-header__menu-btn'); 
        const links = document.querySelectorAll('.tlp-header__menu a'); 
        
        if (toggle && links.length) { 
            const update = () => { 
                const expanded = toggle.getAttribute('aria-expanded') === 'true'; 
                links.forEach(link => { 
                    if (expanded) { 
                        link.removeAttribute('tabindex'); 
                    } else { 
                        link.setAttribute('tabindex', '-1'); 
                    } 
                }); 
            }; 
            
            const observer = new MutationObserver(update); observer.observe(toggle, { attributes: true, attributeFilter: ['aria-expanded'] }); update(); 
        }
    }

    /* ==========================================================================
    = Accessibility Statement Page Accessibility Fixes 
    ========================================================================== */

    if (
        window.location.pathname === "/pages/accessibility-statement" ||
        window.location.pathname === "/pages/accessibility-statement/"
    ) {

        /* = External link indicator
        -------------------------------------------------------------- */

        document.addEventListener('DOMContentLoaded', () => { 
            const link = document.querySelector('.nss-richtext a[href="https://www.w3.org/WAI/standards-guidelines/wcag/"][target="_blank"]'); 
            
            if (link) { 
                link.insertAdjacentHTML('beforeend', ' <span aria-hidden="true">↗</span><span class="sr-only">Opens in a new tab</span>'); 
            } 
        });
    }

    /* ==========================================================================
    = APPI Compliance Page Accessibility Fixes 
    ========================================================================== */

    /* = Abbreviation accessibility for screen readers
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', function () {
        const map = {
            VCDPA: 'V C D P A',
            CTDPA: 'C T D P A',
            PIPEDA: 'P I P E D A',
            LGPD: 'L G P D',
            GDPR: 'G D P R',
            CCPA: 'C C P A',
            CPRA: 'C P R A',
            CPA: 'C P A',
            UCPA: 'U C P A',
            APPI: 'A P P I'
        };

        const container = document.querySelector('#appi_page .text-center');
        if (!container) return;

        let html = container.innerHTML;

        Object.keys(map).forEach(abbrev => {
            const regex = new RegExp(`\\b${abbrev}\\b`, 'g');
            html = html.replace(
            regex,
            `<span aria-label="${map[abbrev]}">${abbrev}</span>`
            );
        });

        container.innerHTML = html;
    });

    /* ==========================================================================
    = CCPA Opt-Out Page Accessibility Fixes 
    ========================================================================== */

    /* = Button arrow colour contrast fix
    -------------------------------------------------------------- */

    if (
        window.location.pathname === "/pages/ccpa-opt-out" ||
        window.location.pathname === "/pages/ccpa-opt-out/"
    ) {
       document.addEventListener("DOMContentLoaded", function () {
           document.body.classList.add("nss-ccpa-opt-out");
       });
    }

    /* ==========================================================================
    = Bazaar Reviews App Accessibility Fixes 
    ========================================================================== */

    /* = Reviews link replacement with div
    -------------------------------------------------------------- */

    const interval = setInterval(() => {
        const links = document.querySelectorAll(
            'a.bv_inline_rating_container_left'
        );

        if (!links.length) return;

        links.forEach(link => {
            const div = document.createElement('div');

            [...link.attributes].forEach(attr => {
                if (attr.name !== 'href') {
                    div.setAttribute(attr.name, attr.value);
                }
            });

            div.innerHTML = link.innerHTML;

            link.replaceWith(div);
        });

        clearInterval(interval);

        console.log('Bazaarvoice links replaced');
    }, 500);

    /* ==========================================================================
    = hCaptcha Accessibility Fixes 
    ========================================================================== */

    /* = Link focus management
    -------------------------------------------------------------- */

    (function () {
        function patchHCaptchaLinks() {
            var badge = document.getElementById('shop-hcaptcha-badge-container');
            if (!badge) return;

            var links = badge.querySelectorAll('.links a');
            links.forEach(function (link) {
            link.setAttribute('tabindex', '-1');
            });
        }

        document.addEventListener('DOMContentLoaded', patchHCaptchaLinks);

        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (!(node instanceof HTMLElement)) return;

                if (node.id === 'shop-hcaptcha-badge-container' ||
                    node.querySelector('#shop-hcaptcha-badge-container')) {
                patchHCaptchaLinks();
                }
            });
        });
    });

    observer.observe(document.documentElement, {
        childList: true,
        subtree: true
    });
    })();

    /* ==========================================================================
    = Klaviyo Accessibility Fixes 
    ========================================================================== */

    /* = Form field accessibility enhancements
    -------------------------------------------------------------- */

    function enhanceKlaviyoEmailField() {
        const container = document.querySelector('.klaviyo-form');
        if (!container) return;

        const emailInput = container.querySelector('input[type="email"]');
        if (!emailInput) return;

        emailInput.removeAttribute('aria-label');
        emailInput.id = 'klaviyo-email-field';

        if (!container.querySelector('label[for="klaviyo-email-field"]')) {
            const label = document.createElement('label');
            label.setAttribute('for', 'klaviyo-email-field');
            label.textContent = 'Email address';
            label.style.color = '#fff';
            label.style.fontSize = '18px';
            label.style.marginBottom = '10px';
            emailInput.parentNode.insertBefore(label, emailInput);
            emailInput.removeAttribute('placeholder');
        }

        const describedBy = emailInput.getAttribute('aria-describedby'); 
        if (!describedBy) return;

        const errorEl = document.getElementById(describedBy); 
        if (!errorEl) return;

        const text = errorEl.textContent.trim();
        if (!text) return;

        if (text === 'This field is required') { 
            errorEl.textContent = 'Please enter your email address.'; 
        }

        errorEl.removeAttribute('role'); 
        errorEl.removeAttribute('aria-live'); 
        errorEl.setAttribute('role', 'status');
    }

    const observer = new MutationObserver(enhanceKlaviyoEmailField);
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('DOMContentLoaded', enhanceKlaviyoEmailField);

    /* ==========================================================================
    = Swiper Slide Accessibility Fixes 
    ========================================================================== */

    /* = Group role removal
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', function () { 
        document.querySelectorAll('li.swiper-slide[role="group"]').forEach(function (slide) { 
            slide.removeAttribute('role'); 
        }); 
    });

    /* ==========================================================================
    = Wonderment App Accessibility Fixes 
    ========================================================================== */

    /* = Email error validation
    -------------------------------------------------------------- */

    document.addEventListener('DOMContentLoaded', () => {
        const observer = new MutationObserver(() => {
            const emailInput = document.querySelector(
            '.wonderment-ab-container input[aria-label="Email address"]'
            );

            if (!emailInput || emailInput.dataset.emailPatched) {
            return;
            }

            emailInput.dataset.emailPatched = 'true';
            emailInput.setAttribute('type', 'email');
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });

    /* ==========================================================================
    = Yotpo Accessibility Fixes 
    ========================================================================== */

    /* = Focus management
    -------------------------------------------------------------- */

    function fixYotpoContainer () { 
        document.querySelectorAll('.yotpo-bottomline[tabindex="0"]').forEach(el => { 
            el.removeAttribute('tabindex'); 
        });
    }

    function replaceYotpoReviewLink() {
        const links = document.querySelectorAll('.yotpo-bottomline a.text-m'); 
        links.forEach(a => { 
            const span = document.createElement('span'); 
            span.className = a.className; 
            span.textContent = a.textContent; 
            a.replaceWith(span); 
        }); 
    }

    /* = Arrow control labels
    -------------------------------------------------------------- */

    function fixYotpoNavLabels() { 
        const prev = document.querySelector('.yotpo-icon-left-arrow-light[role="button"]'); 
        const next = document.querySelector('.yotpo-icon-right-arrow-light[role="button"]'); 
        
        if (prev) prev.setAttribute('aria-label', 'Previous review'); 
        if (next) next.setAttribute('aria-label', 'Next review');
    }

    /* = Summary attributes removal
    -------------------------------------------------------------- */

    function fixYotpoSummary() { 
        document.querySelectorAll('.yotpo-paragraph-summary-content').forEach(el => { 
            el.removeAttribute('role');
            el.removeAttribute('tabindex'); 
            el.removeAttribute('aria-label'); 
        }); 
    }

    /* = Summary button keyboard controls
    -------------------------------------------------------------- */

    function fixYotpoSummaryButton() { 
        document.querySelectorAll('.yotpo-reviews-summary-button[role="button"]').forEach(el => { 
            el.addEventListener('keydown', e => { 
                if (e.code === 'Space' || e.key === ' ') { 
                    e.preventDefault(); 
                    el.click(); 
                } 
            }); 
        }); 
    }

    /* = Topics heading level
    -------------------------------------------------------------- */

    function fixYotpoPopularTopicsHeading() { 
        document.querySelectorAll('.yotpo-smart-topics-headline').forEach(el => { 
            el.setAttribute('role', 'heading'); 
            el.setAttribute('aria-level', '4'); 
        }); 
    }

    /* = Search button label
    -------------------------------------------------------------- */

    function fixYotpoSearchButtonLabel() {
        const observer = new MutationObserver((mutations, obs) => {
            const btn = document.querySelector('.yotpo-icon-button');
            if (!btn) return;

            btn.setAttribute('aria-label', 'Search reviews');

            obs.disconnect();
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    /* = Show more toggle ARIA markup
    -------------------------------------------------------------- */

    function fixYotpoShowMoreAccessibility() {
        const observer = new MutationObserver(() => {
            const btn = document.querySelector('.yotpo-smart-topics-see-more-label');
            if (!btn) return;

            btn.setAttribute('aria-label', 'Show more review topics');

            btn.addEventListener('click', () => {
                const pressed = btn.getAttribute('aria-pressed') === 'true'; 
                btn.setAttribute('aria-label', pressed ? 'Show fewer review topics' : 'Show more review topics');
            });

            observer.disconnect();
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    /* = Show more button focus management
    -------------------------------------------------------------- */

    function fixYotpoShowMoreFocus() {
        const containerSelector = '.smart-topic-collection'; 
        const showMoreSelector = '.yotpo-smart-topics-see-more-label';

        const container = document.querySelector(containerSelector);
        if (!container) return;

        let previousCount = container.querySelectorAll('.yotpo-smart-topic-filter').length;

        document.addEventListener('click', (event) => {
            const btn = event.target.closest(showMoreSelector); 
            if (!btn) return;

            setTimeout(() => {
                const topics = container.querySelectorAll('.yotpo-smart-topic-filter');
                const newCount = topics.length;

                if (newCount > previousCount) {
                    const firstNewTopic = topics[previousCount];
                    if (firstNewTopic) firstNewTopic.focus();
                }

                previousCount = newCount;
            }, 300);
        });
    }

    /* = Read more button ARIA markup
    -------------------------------------------------------------- */

    function fixYotpoReadMoreLabels() {
        const observer = new MutationObserver(() => {
            const reviews = document.querySelectorAll('.yotpo-reviews-item');

            reviews.forEach((review, index) => {
                const btn = review.querySelector('.yotpo-read-more');
                if (!btn) return;

                const reviewNumber = index + 1;
                const isExpanded = btn.getAttribute('aria-expanded') === 'true';

                const label = isExpanded ? `Read less of review ${reviewNumber}` : `Read more from review ${reviewNumber}`;

                btn.setAttribute('aria-label', label);
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    /* = Upload instructions
    -------------------------------------------------------------- */

    function fixYotpoUploadInstructions() {
        const observer = new MutationObserver(() => {
            const uploadButton = document.querySelector('.yotpo-upload-label');
            const instructionNodes = document.querySelectorAll('.yotpo-new-input-message');

            if (!uploadButton || instructionNodes.length === 0) return;

            const instructions = instructionNodes[instructionNodes.length - 1];

            if (instructions.id !== 'yotpo-upload-instructions') { 
                instructions.id = 'yotpo-upload-instructions'; 
            }

            if (uploadButton.getAttribute('aria-describedby') !== 'yotpo-upload-instructions') { 
                uploadButton.setAttribute('aria-describedby', 'yotpo-upload-instructions'); 
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    /* = Summary button label
    -------------------------------------------------------------- */

    function fixYotpoSummaryButtonLabel() {
      const observer = new MutationObserver((mutations, obs) => {
          const btn = document.querySelector('.yotpo-reviews-summary-button');
          
          if (!btn) return;
          
          const textNode = btn.querySelector('.yotpo-reviews-summary-button-text');
   
          if (!textNode) return;
  
          const visibleText = textNode.textContent.trim();
          const correctLabel = `${visibleText} – view detailed reviews summary`;
  
          btn.setAttribute('aria-label', correctLabel);
  
          obs.disconnect();
      });
  
      observer.observe(document.body, { childList: true, subtree: true });
    }

    /* = Initialise Yotpo fixes
    -------------------------------------------------------------- */

    function fixYotpo() { 
        fixYotpoContainer(); 
        replaceYotpoReviewLink();
        fixYotpoNavLabels();
        fixYotpoSummary();
        fixYotpoSummaryButton();
        fixYotpoPopularTopicsHeading();
        fixYotpoSearchButtonLabel();
        fixYotpoShowMoreAccessibility();
        fixYotpoShowMoreFocus();
        fixYotpoReadMoreLabels();
        fixYotpoUploadInstructions();
        fixYotpoSummaryButtonLabel();
    }

    function waitForYotpo() {
        const yotpoEl = document.querySelector('.yotpo-bottomline');

        if (yotpoEl) {
            fixYotpo();

            const observer = new MutationObserver(() => { 
                fixYotpo(); 
            });

            observer.observe(document.body, { 
                childList: true, 
                subtree: true 
            });
        } else {
            setTimeout(waitForYotpo, 200);
        }
    }

    waitForYotpo();
})();